{
    "Api tokens": {
        "add token": "Tambahkan token",
        "description": "Menghasilkan token API untuk pengunduhan berkas OEM untuk TCT dan Configurator atau token API yang digunakan aplikasi saat meminta layanan FOTA WEB. Dokumentasi API dapat ditemukan <1>di sini</1>.",
        "example": "Contoh: fota_token",
        "generate token": "Buat token",
        "generated token": "Token yang dihasilkan",
        "last used at": "Terakhir digunakan pada",
        "name": "Nama token",
        "never": "Tidak pernah",
        "no tokens": "Tidak ada token yang tersedia",
        "no tokens description": "Setelah token ditambahkan, token tersebut akan terdaftar di bawah ini",
        "show token list": "Tampilkan daftar token",
        "titles": {
            "Integration": {
                "description": "Digunakan untuk integrasi FOTA WEB dalam sistem Anda",
                "name": "Token integrasi API"
            },
            "Tct": {
                "description": "Digunakan untuk mengunduh file OEM untuk TCT dan Configurator",
                "name": "Token TCT"
            }
        },
        "tokens": "Token API",
        "token type": "Jenis token",
        "token was created": "Token telah berhasil dibuat"
    },
    "Attributes": {
        "Completed": "Selesai",
        "Count": "Jumlah",
        "Current": "Saat ini",
        "Date": "Tanggal",
        "Empty": "Kosong",
        "excluded files": "File yang dikecualikan (samegrade)",
        "Failed": "Gagal",
        "false": "",
        "Feature": "Fitur",
        "file size bytes": "Ukuran total file",
        "File_type": "Jenis file",
        "File_version": "Versi file",
        "Fingerprint_id": "ID Sidik Jari",
        "Firmware_date": "Tanggal firmware",
        "Firmware_version": "Revisi",
        "included files": "Berkas yang disertakan",
        "Include_j1939": "",
        "Message": "Pesan",
        "Metadata": "",
        "newest": "Dari yang terbaru",
        "oldest": "Dari yang tertua",
        "Order": "Pesan",
        "Password_source": "",
        "Pending": "Menunggu",
        "Period": "Periode",
        "Process_id": "",
        "Protocol_id": "ID Protokol",
        "Reported_count": "",
        "Requested_count": "",
        "specific": "Spesifik",
        "Start": "Mulai",
        "SystemGenerated": "",
        "true": "",
        "txFwBundleFileTypes": {
            "fw_bundle_ble": "Firmware BLE",
            "fw_bundle_ble_dtb": "BLE DTB",
            "fw_bundle_can": "Firmware CAN",
            "fw_bundle_can_dtb": "CAN DTB",
            "fw_bundle_dtb": "TAPP DTB",
            "fw_bundle_mainfw": "Firmware TAPP"
        },
        "UserEntered": "",
        "vehicle": "Kendaraan",
        "Vehicle_id": "ID Kendaraan",
        "Vin": "VIN"
    },
    "Auth": {
        "account verification": {
            "check autheticator": "Periksa aplikasi autentikator Anda",
            "check email": "Periksa email Anda",
            "code required": "Diperlukan kode verifikasi.",
            "code sent to email": "Kode dikirim ke email Anda",
            "code valid": "Kode ini berlaku selama beberapa menit.",
            "enter code below": "dan masukkan kode di bawah ini untuk masuk.",
            "no access to otp": "Tidak bisa mengakses perangkat Anda?",
            "recovery code": {
                "banner text": "Setelah masuk menggunakan kode pemulihan, Anda akan diminta untuk mengonfigurasi ulang otentikasi dua faktor Anda guna menjaga keamanan akun Anda.",
                "description": "Masukkan salah satu kode pemulihan Anda untuk masuk. Setiap kode hanya dapat digunakan sekali.",
                "secondary text": "Masukkan salah satu kode pemulihan Anda untuk masuk. Setiap kode hanya dapat digunakan sekali.",
                "title": "Kode pemulihan"
            },
            "title": "Verifikasi akun",
            "use recovery code": "Gunakan kode pemulihan."
        },
        "account verification description": "Diperlukan kode verifikasi. Periksa aplikasi autentikator Anda dan masukkan kode di bawah ini untuk masuk.",
        "check email": "Silakan periksa kotak masuk Anda dan klik tautan yang diterima untuk mereset kata sandi.",
        "community forum": "Forum dukungan komunitas",
        "contact us": "Hubungi kami",
        "create initial password": "Buat kata sandi",
        "create password": "Buat kata sandi yang",
        "did not receive": "Belum menerima tautannya?",
        "do not have account": "Belum punya akun?",
        "email": "Email",
        "enter email": "Silakan masukkan alamat email terdaftar Anda di bawah ini untuk menerima petunjuk reset kata sandi.",
        "forgot password": "Lupa Kata Sandi?",
        "forgot your password": "Lupa kata sandi Anda?",
        "for ms365": "Untuk pengguna Teltonika MS365",
        "invalid email format": "Format email tidak valid",
        "invalid password format": "Format kata sandi tidak valid",
        "link sent": "Tautan telah dikirim!",
        "length": "Minimal 8 karakter",
        "lowercase": "Mengandung setidaknya 1 huruf kecil",
        "new password": "Kata sandi baru",
        "password": "Kata sandi",
        "passwords do not match": "Kata sandi tidak cocok",
        "privacy policy": "Dengan menggunakan FOTA WEB, Anda menyetujui <1>Kebijakan Privasi</1> kami.",
        "remember password": "Apakah Anda ingat kata sandi Anda?",
        "repeat password": "Ulangi kata sandi",
        "required": "Diperlukan",
        "resend": "Kirim ulang",
        "reset password": "Reset kata sandi",
        "send reset link": "Kirim tautan reset",
        "sign in": "Masuk",
        "sign in to fota": "Masuk ke akun\nFOTA WEB Anda",
        "signup": "Daftar",
        "sso": "Masuk dengan Microsoft",
        "teltonika telematics": "Teltonika Telematics",
        "uppercase": "Huruf besar",
        "user consent text": "Saya memahami dan menyetujui <1>Ketentuan Layanan</1> Teltonika dan <2>Perjanjian Pemrosesan Data</2>.",
        "welcome": "Selamat datang di",
        "wiki": "Basis Pengetahuan Telematics Wiki"
    },
    "Banner": {
        "activate banner": "Aktifkan banner",
        "apply link": "Tautan pendaftaran",
        "banner importance": "Pentingnya banner",
        "bold": "Tebal",
        "close link": "Tutup tautan",
        "info": "Informasi",
        "italic": "Miring",
        "link": "Tautan",
        "message": "Pesan",
        "text": "Teks (opsional)",
        "underline": "Garis bawah",
        "url": "URL",
        "warning": "Peringatan"
    },
    "Button": {
        "accept": "Setuju",
        "accept all": "Terima semua",
        "accept selected": "Terima pilihan",
        "actions": "Tindakan",
        "add": "Tambahkan",
        "add device": "Tambahkan perangkat",
        "add more files": "Tambahkan lebih banyak file",
        "add new": "Tambahkan baru",
        "agree": "Saya setuju",
        "all companies": "Semua perusahaan",
        "all of company": "Semua dari {{companyName}}",
        "all rows selected": {
            "devices": "Semua {{count}} perangkat telah dipilih",
            "tasks": "Semua {{count}} tugas yang tertunda/sedang berjalan telah dipilih",
            "groups": "Semua {{count}} grup telah dipilih",
            "files": "Semua {{count}} file telah dipilih",
            "companies": "Semua {{count}} perusahaan telah dipilih",
            "users": "Semua {{count}} pengguna telah dipilih"
        },
        "approve": "Setujui",
        "assign": "Tugaskan",
        "assigning": "Penugasan",
        "auto sync": "",
        "back": "Kembali",
        "back to sign in": "Kembali ke halaman masuk",
        "cancel": "Batal",
        "cancelling": "Pembatalan",
        "cancel all tasks in group": "Batalkan semua tugas dalam grup",
        "cancel tasks": "Batalkan tugas",
        "cannot create desktop licenses": "Lisensi tidak dapat dibuat untuk perusahaan internal.",
        "cannot create offline licenses": "Lisensi offline tidak dapat dibuat untuk lisensi tanpa batasan.",
        "change": "Ubah",
        "clear all": "Hapus semua",
        "clear all filters": "Hapus semua filter",
        "close": "Tutup",
        "company settings": "Pengaturan perusahaan",
        "confirm": "Konfirmasi",
        "continue": "Lanjutkan",
        "copied": "Disalin",
        "copy all": "Salin semua",
        "copy to clipboard": "Salin ke papan klip",
        "create": "Buat",
        "create role": "Buat peran",
        "create task": "Buat tugas",
        "creating": "Membuat",
        "default view": "Tampilan default",
        "delete": "Hapus",
        "deleting": "Menghapus",
        "deselect all": "Batalkan pemilihan semua",
        "device": "Perangkat",
        "disable": "Nonaktifkan",
        "disagree": "Saya tidak setuju",
        "discard": "Hapus",
        "download": "Unduh",
        "edit": "Edit",
        "enable": "Aktifkan",
        "export": "Ekspor",
        "exporting": "Ekspor",
        "filters": "Filter",
        "finish": "Selesai",
        "find tool": "Temukan alat",
        "first page": "Halaman utama",
        "generate": "Buat",
        "generate codes": "Membuat kode",
        "go back": "Kembali",
        "import": "Impor",
        "importing": "Impor",
        "invite": "Undang",
        "invite user": "Undang pengguna",
        "invite user to internal disabled": "Hanya Admin Manager dan tingkat akses yang lebih tinggi yang dapat mengundang pengguna ke perusahaan internal.",
        "language": "Bahasa",
        "last page": "Halaman terakhir",
        "logout": "Keluar",
        "maximize details": "Lihat detail selengkapnya",
        "merge": "Gabungkan",
        "merging": "Penggabungan",
        "minimize details": "Sederhanakan detail",
        "more actions": "Tindakan lainnya",
        "more filters": "Filter lainnya",
        "more options": "Opsi lainnya",
        "move": "Pindahkan",
        "moving": "Pindah",
        "next": "Selanjutnya",
        "next month": "Bulan depan",
        "next page": "Halaman berikutnya",
        "no actions available": "Tidak ada tindakan yang tersedia",
        "no permission": "Anda memerlukan izin \"{{permissionName}}\".",
        "no permissions": "Anda memerlukan izin berikut: {{permissionNames}}.",
        "notify when done": "Beritahu saya saat selesai",
        "number of selected companies": "{{companyCount}} dari {{companyName}}",
        "only essential": "Hanya yang penting",
        "open fota web": "Open FOTA WEB",
        "pages of": "dari {{total}}",
        "previous month": "Bulan lalu",
        "previous page": "Halaman sebelumnya",
        "print": "Cetak",
        "receive devices": "Menerima perangkat",
        "refresh page": "Segarkan",
        "reject all": "Tolak semua",
        "reset to default": "Kembalikan ke pengaturan default",
        "retry failed tasks": "Ulangi tugas yang gagal",
        "retrying": "Mencoba lagi",
        "return home": "Ayo pulang",
        "revert manual level change": "Kembalikan perubahan level manual",
        "rows count per page": "Jumlah baris per halaman",
        "rows selected": "{{count}} Terpilih",
        "save": "Simpan",
        "saving": "",
        "see all": "Lihat semua",
        "select all": {
            "devices": "Pilih semua {{count}} perangkat",
            "tasks": "Pilih semua {{count}} tugas yang tertunda/sedang berjalan",
            "groups": "Pilih semua {{count}} grup",
            "files": "Pilih semua {{count}} file",
            "companies": "Pilih semua {{count}} perusahaan",
            "users": "Pilih semua {{count}} pengguna"
        },
        "select columns to show": "Pilih kolom yang akan ditampilkan",
        "selected page is first": "Halaman yang dipilih adalah halaman pertama",
        "selected page is last": "Halaman yang dipilih adalah halaman terakhir",
        "select rows": "Pilih baris",
        "send code": "Kirim kode",
        "settings": "Pengaturan",
        "show me": "Tunjukkan kepada saya",
        "show more": "Tampilkan lebih banyak",
        "synchronize": "Sinkronisasi",
        "table statistics": "Statistik tabel",
        "table view": "Tampilan tabel",
        "transfer": "Transfer",
        "transferring": "Transfer",
        "transfer my devices": "Pindahkan perangkat saya",
        "undo": "Batal",
        "upload": "Unggah",
        "upload file": "Unggah file baru",
        "user": "Pengguna",
        "verify": "Verifikasi",
        "yes": "Ya"
    },
    "Cookies": {
        "always active": "Selalu aktif",
        "analytics cookies": "Cookie analitik",
        "analytics cookies description": "Pelacak ini digunakan untuk analisis guna membantu mengumpulkan data yang memungkinkan kami memahami bagaimana pengguna berinteraksi dengan situs web kami. Wawasan ini memungkinkan kami untuk meningkatkan konten dan mengembangkan fitur yang lebih baik guna meningkatkan pengalaman pengguna. Kategori cookie ini dapat dinonaktifkan.",
        "cookie banner message": "Kami dan pihak ketiga terpilih menggunakan cookie atau teknologi serupa untuk tujuan teknis dan, dengan persetujuan Anda, untuk tujuan lain sebagaimana dijelaskan dalam ",
        "cookie modal title": "Kami menggunakan cookie",
        "cookie policy": "kebijakan cookie",
        "essential cookies": "Cookie penting",
        "essential cookies description": "Pelacak ini digunakan untuk aktivitas yang benar-benar diperlukan untuk mengoperasikan atau menyediakan layanan yang Anda minta dari kami, dan cookie ini tidak mengumpulkan informasi tentang Anda yang dapat digunakan untuk tujuan pemasaran serta tidak mencatat riwayat penelusuran Anda di internet. Kategori cookie ini tidak dapat dinonaktifkan."
    },
    "Dashboard": {
        "company level": {
            "description": {
                "Basic": "Hal-hal penting untuk pembaruan perangkat jarak jauh",
                "Standard": "Otomatisasi dan integrasi tingkat lanjut",
                "Premium": "Skalabilitas untuk perusahaan dan akses awal ke pembaruan"
            },
            "resource limit types": {
                "Companies": "Perusahaan",
                "Users": "Pengguna",
                "ConfigurationFiles": "Berkas konfigurasi"
            }
        },
        "empty state": {
            "description": {
                "configurations": "Segera setelah konfigurasi terdeteksi oleh FOTA WEB, Anda dapat melihat daftarnya di sini.",
                "firmware versions": "Segera setelah versi firmware terdeteksi oleh FOTA WEB, Anda dapat melihat daftarnya di sini."
            },
            "title": {
                "configurations": "Tidak ada konfigurasi yang terdeteksi",
                "firmware versions": "Tidak terdeteksi versi firmware",
                "news": "Tidak ada berita yang ditampilkan"
            }
        },
        "imported activated devices": {
            "days": {
                "1": "Hari ini",
                "7": "7 hari",
                "30": "30 hari",
                "90": "90 hari"
            },
            "period": "Periode"
        },
        "new": "",
        "news": {
            "body": {
                "1": "Kami ingin mengingatkan Anda bahwa bagi pengguna yang diundang setelah 7 Januari 2025, otentikasi dua faktor (2FA) akan menjadi wajib segera setelah akun diaktifkan. Otentikasi dua faktor tersedia melalui verifikasi email atau aplikasi otentikator.",
                "2": "Kami ingin menginformasikan kepada Anda mengenai pemeliharaan FOTA WEB yang direncanakan akan dilaksanakan pada tanggal 3 Juni 2025 mulai pukul 05:00 UTC. Harap diperhatikan bahwa selama pemeliharaan, semua layanan tidak akan tersedia, termasuk antarmuka pengguna, akses API, eksekusi tugas, layanan OBD, dan layanan CAN. Perkiraan waktu ketidak Tersediaannya layanan adalah 1 jam.",
                "3": "<section><p>Dengan gembira kami mengumumkan peningkatan penting pada fitur Device Unlocker di FOTA WEB:</p></section> <section><p>Semua peran pengguna kini dapat membuka kunci perangkat secara langsung — tidak perlu menghubungi Dukungan Teknis melalui Helpdesk!</p> <p>Detail Utama:</p> <ul><li>Pengguna dapat membuka kunci perangkat yang sama hingga 3 kali dalam periode 24 jam.</li> <li>Setelah mencapai batas, opsi pembukaan kunci akan dinonaktifkan sementara selama 24 jam.</li> <li>Jika batas pembukaan kunci terlampaui, pesan kesalahan akan muncul. Pembaruan ini secara signifikan mengurangi waktu tunggu dan memberi Anda kontrol lebih besar atas manajemen armada Anda.</li></ul></section> <section><a>Pelajari cara menggunakan fitur ini</a></section>",
                "4": "<section><p>Kami dengan senang hati mengumumkan beberapa pembaruan menarik pada dasbor FOTA WEB! Kami telah berupaya meningkatkan pengalaman Anda dengan widget yang ditingkatkan dan wawasan baru.</p></section><section><h3>Statistik Perangkat Baru</h3></section> <section><p>Dapatkan wawasan yang lebih baik tentang aktivitas perangkat Anda dengan dua widget baru:</p> <p><strong>Perangkat yang diaktifkan</strong>: Statistik baru ini menunjukkan berapa banyak perangkat yang telah diaktifkan (terhubung) selama periode tertentu: Hari ini, 7 hari, 30 hari, atau 90 hari.</p> <p><strong>Perangkat yang Diimpor</strong>: Demikian pula, statistik Perangkat yang Diimpor baru melacak berapa banyak perangkat yang telah diimpor selama periode Hari ini, 7 hari, 30 hari, atau 90 hari.</p> </section> <section><h3>Memperkenalkan Widget Tugas</h3></section> <section><p>Pantau operasi Anda dengan widget Tugas yang sepenuhnya baru:</p> <p><strong>Tugas yang sedang antre</strong>: Lihat jumlah yang jelas dari tugas-tugas Anda yang saat ini sedang menunggu.</p> <p><strong>Ringkasan Tugas</strong>: Dapatkan rincian distribusi tugas Anda berdasarkan periode (7 hari, 30 hari, atau 90 hari) dan status. Ini mencakup tugas yang Selesai, Selesai dengan kesalahan, atau Gagal.</p></section> <section><h3>Ringkasan Firmware dan Konfigurasi yang Lebih Cerdas</h3></section> <section><p>Kami telah menyempurnakan widget Versi Firmware dan Konfigurasi:</p> <ul><li>Kami telah menghapus statistik \"Tidak Diketahui\" untuk data yang lebih rapi.</li> <li>Antarmuka pengguna kini menampilkan nama firmware dan konfigurasi serta jumlahnya dengan lebih jelas.</li> <li>Anda akan melihat 5 versi atau konfigurasi teratas pada awalnya, dengan opsi \"Tampilkan lebih banyak\" untuk melihat hingga 100 entri berbeda.</li> <li>Menyorot dan mengklik firmware atau konfigurasi tertentu akan membawa Anda ke \"Halaman Perangkat\" dan menerapkan filter.</li></ul></section> <section><h3>Widget Berita yang Ditingkatkan</h3></section> <section><p>Tetap terinformasi sekilas! Widget Berita memiliki tampilan baru yang segar, dan kini Anda juga dapat mengklik item berita apa pun untuk membaca informasi lengkapnya.</p></section> <section><h3>Status Perangkat yang Ditingkatkan</h3></section> <section><p>Widget Status Perangkat telah diperbarui secara visual untuk kejelasan. Selain itu, Anda kini dapat mengarahkan kursor ke status perangkat dan mengkliknya untuk menyaring perangkat dengan status yang sesuai di halaman \"Perangkat\".</p></section> <section><p>Kami harap pembaruan ini membuat tugas harian Anda semakin mudah dan memberikan informasi yang lebih berharga. Beritahu kami pendapat Anda!</p></section>",
                "5": "<section><h3>Perubahan API yang Direncanakan</h3></section> <section><p>Pada <strong>24 September 2025</strong>, kami akan menghapus bidang \"role\" dari respons yang mengembalikan entitas pengguna (misalnya, endpoint GET /users atau GET /users/{userId}). Perubahan ini dilakukan untuk membuka jalan bagi sistem izin yang lebih kuat dan fleksibel di FOTA WEB.</p></section> <section><h3>Sekilas: Peran dan Izin</h3></section> <section><p>  Kami menyadari bahwa sistem peran saat ini tidak memberikan fleksibilitas yang Anda butuhkan. Tim pengembangan kami sedang bekerja keras pada fitur baru <strong>Manajemen Peran dan Izin</strong> yang akan memungkinkan Anda membuat peran dengan kontrol izin yang lebih terperinci.</p></section>  <section><p>Sistem baru ini akan memberi Anda kemampuan untuk menetapkan peran statis kepada pengguna atau menyesuaikan izin sesuai kebutuhan spesifik Anda, serta membuat peran kustom. Kami sangat antusias dengan hal ini dan menantikan untuk membagikan detail lebih lanjut mengenai manajemen Peran dan Izin saat sudah tersedia.</p></section>",
                "6": "<section><p>Dengan senang hati kami mengumumkan peluncuran fitur baru <strong>\"Peran dan Izin\"</strong>, yang dirancang untuk memberi Anda kontrol yang tepat atas akses pengguna di dalam FOTA WEB. Fungsi ini memungkinkan Anda menentukan kemampuan pengguna menggunakan <strong>Peran</strong>, yang merupakan kumpulan <strong>Izin</strong> tertentu (misalnya, \"Buat tugas\", \"Undang pengguna\"). Fitur ini mencakup <strong>Peran Statis</strong> yang tidak dapat diubah - Administrator, Pengguna, dan Tamu - untuk keamanan dasar, serta <strong>Peran Kustom</strong> yang dapat disesuaikan, yang hanya dapat dibuat atau diedit oleh pengguna <strong>tingkat perusahaan Premium</strong>. Izin kini dikategorikan ke dalam area utama seperti Perangkat, Tugas, dan Pengguna, dan dapat dilihat dengan mengarahkan kursor ke \"Jumlah Izin\" di bagian manajemen. <strong>Untuk semua pengguna yang sudah ada yang dibuat sebelum pembaruan ini, mereka telah secara otomatis ditugaskan peran \"Administrator\", memastikan mereka tetap memiliki rentang tindakan penuh yang dapat mereka lakukan sebelumnya.</strong></p></section> <section><p>Pembaruan ini memastikan keamanan yang lebih baik dan distribusi beban kerja. Peran kini bersifat spesifik perusahaan dan tidak dapat diwariskan antar struktur perusahaan. Perhatikan bahwa peran harus selalu ditugaskan saat mengundang atau memindahkan pengguna ke perusahaan, dan peran dengan penugasan pengguna aktif tidak dapat dihapus. Anda kini dapat menggunakan <strong>filter \"Peran\" baru</strong> di halaman <strong>Pengguna</strong> untuk pengelolaan yang lebih mudah. Jelajahi bagian \"Peran dan Izin\" hari ini untuk mengonfigurasi akses yang disesuaikan dengan kebutuhan organisasi Anda.</p></section> <section><p>Untuk panduan terperinci tentang pengelolaan pengguna dan peran, silakan kunjungi <a>halaman wiki</a>.</p></section>",
                "7": "<section><p>Kami dengan senang hati meluncurkan cara baru yang canggih untuk mengelola tugas Anda dengan fitur <strong>Jadwalkan berdasarkan tanggal</strong>, yang memberikan Anda presisi lebih tinggi untuk pekerjaan yang sensitif terhadap waktu!</p></section> <section><h3>Sorotan utama</h3></section> <section><ul><li><strong>Batas waktu tertentu</strong> - Anda kini dapat menjadwalkan tugas untuk <strong>tanggal tertentu atau rentang tanggal</strong> menggunakan opsi baru \"Jadwalkan berdasarkan tanggal\".</li> <li><strong>Perilaku default tetap sama</strong> - Fungsi <strong>Jadwalkan berdasarkan waktu</strong> yang sudah dikenal tetap tersedia sepenuhnya.</li> <li><strong>Status kedaluwarsa</strong> - Tugas yang tidak diselesaikan pada tanggal yang ditetapkan kini akan secara otomatis berubah status menjadi <strong>Kedaluwarsa</strong>, disertai pesan: <strong>\"Tugas tidak diselesaikan selama jadwal yang ditetapkan.\"</strong></li> <li><strong>Penjadwalan berdasarkan waktu pengguna</strong> - Semua jadwal dibuat berdasarkan <strong>waktu lokal Anda</strong>.</li></ul></section> <section><h3>Cara kerjanya</h3></section> <section><p>Saat mengatur tugas <strong>\"Jadwalkan berdasarkan tanggal\"</strong>:</p> <ul><li>Anda akan memilih <strong>\"Tanggal mulai\"</strong> dan <strong>\"Tanggal akhir\"</strong> melalui komponen pemilih tanggal.</li> <li>Pemilih tanggal mengikuti batas waktu kedaluwarsa tugas tingkat perusahaan.</li></ul></section><section><p>Fungsi <strong>Jadwalkan berdasarkan tanggal</strong> saat ini eksklusif untuk tingkat perusahaan yang lebih tinggi dan tidak tersedia untuk tingkatan <strong>Basic</strong>.</p></section>",
                "8": "<section><p>Kami telah meningkatkan perangkat administrasi Anda! Kini Anda dapat mengelola seluruh siklus hidup akun pengguna mulai dari saat undangan hingga masa berlaku berakhir, memastikan data perusahaan Anda tetap aman dan akses tetap bersifat sementara saat diperlukan.</p></section> <section><h3>Apa yang Baru?</h3></section> <section><ul><li><strong>Undangan berjangka waktu</strong> - Tidak ada lagi \"akses selamanya\" secara default. Tetapkan tanggal kedaluwarsa yang pasti saat Anda mengundang anggota tim atau kontraktor baru.</li> <li><strong>Kedaluwarsa retroaktif</strong> - Mudah menerapkan tanggal kedaluwarsa kepada pengguna yang sudah aktif di sistem Anda.</li> <li><strong>Tombol pemutus akses sesuai permintaan</strong> - Perlu menghentikan akses segera? Anda kini dapat menghentikan akses pengguna mana pun secara instan. Jika Anda membutuhkannya kembali, aktifkan kembali dengan dua klik—baik tanpa batas waktu atau dengan timer kedaluwarsa baru.</li></ul> <p><strong>Mengapa ini penting</strong>: Fitur ini sangat cocok untuk mengelola kontraktor eksternal atau staf sementara tanpa perlu mengingat untuk menghapus akun mereka secara manual nanti.</p></section> <section><h3>Tetap Terinformasi</h3></section> <section><p>Kami telah menambahkan lapisan pemberitahuan cerdas sehingga Anda maupun pengguna Anda tidak akan pernah ketinggalan informasi. Sistem kini mengirim email otomatis:</p> <ol><li><strong>Pemberitahuan awal</strong>: Dikirim sesaat sebelum akses akan kedaluwarsa.</li> <li><strong>Transisi</strong>: Dikirim saat akses kedaluwarsa.</li> <li><strong>Selamat datang kembali</strong>: Dikirim segera setelah akun diaktifkan kembali.</li></ol></section> <section><h3>Cara Mengelola Akses</h3></section> <section><p>Akses pengaturan baru ini di halaman <strong>Pengguna</strong>:</p> <ul><li><strong>Saat mengundang</strong>: Cari \"Tanggal Kadaluwarsa\".</li> <li><strong>Untuk pengguna yang sudah ada</strong>: Klik \"Edit\" pada pengguna mana pun untuk mengubah durasi aksesnya.</li> <li><strong>Tindakan instan</strong>: Klik \"Edit\" pada pengguna mana pun dan cari tombol \"Akses\".</li></ul></section>",
                "9": "<section><p>Kami dengan bangga mengumumkan peningkatan signifikan dalam cara Anda mengelola armada perangkat Anda. Kami telah menjembatani kesenjangan fungsional antara platform kami, menghadirkan kemampuan <strong>Smart Device Group</strong> yang canggih ke dalam <strong>platform FT</strong>. Sebelumnya, distribusi file otomatis merupakan fitur mewah yang terutama dinikmati oleh pengguna FMx. Dengan pembaruan ini, kami telah menata ulang logika pengelompokan kami untuk memastikan konsistensi, otomatisasi, dan kejelasan di seluruh ekosistem Anda.</p></section> <section><h3>Apa yang Baru?</h3></section> <section><p>Kami telah memisahkan grup standar dari grup otomatis untuk memberi Anda kontrol lebih besar atas cara perangkat Anda menerima pembaruan.</p> <ul><li><strong>Grup perangkat (standar)</strong> - Cara sederhana untuk mengkategorikan dan mengatur produk Anda. Grup ini tidak berisi file terlampir, sehingga ideal untuk pengelolaan dasar.</li> <li><strong>Grup Perangkat Cerdas</strong> - Di sinilah otomatisasi terjadi. Saat Anda membuat Grup Cerdas, Anda dapat melampirkan file tertentu yang <strong>dikirimkan secara otomatis</strong> ke setiap perangkat dalam grup tersebut.</li> <li><strong>Dukungan lintas platform</strong> - Saat membuat grup, Anda kini dapat memilih \"Buat Grup Cerdas\". Tombol ini membuka kemampuan untuk mengunggah dan mengelola file khusus untuk kedua <strong>platform FT dan FMx</strong> secara bersamaan.</li></ul></section> <section><h3>Mengapa Ini Penting</h3></section> <section><p>Fungsi \"Smart\" dirancang untuk menghemat waktu Anda dan mengurangi kesalahan manusia:</p> <ul><li><strong>Sinkronisasi instan</strong> - Begitu Anda menambahkan perangkat baru ke Grup Cerdas, sistem akan mengidentifikasinya dan segera mengirimkan file yang diperlukan.</li> <li><strong>Kesetaraan</strong> - Pengguna platform FT kini memiliki alat otomatisasi yang sama kuatnya dengan pengguna FMx, memastikan alur kerja yang terpadu terlepas dari perangkat keras yang Anda deploy.</li> <li><strong>Kejelasan</strong> - Dengan memisahkan \"Grup Perangkat\" dari \"Grup Cerdas\", kini langsung jelas mana grup yang secara aktif mengirimkan data ke perangkat keras Anda dan mana yang murni bersifat organisasional.</li></ul></section> <section><h3>Cara Menggunakan Smart Groups</h3></section> <section><p>Anda dapat mulai mengotomatisasi penyebaran Anda di halaman <strong>Grup Perangkat</strong>:</p> <ol><li><strong>Pilih jenis grup</strong> - Klik untuk membuat grup baru dan aktifkan opsi <strong>\"Buat Smart Group\"</strong>.</li> <li><strong>Lampirkan file</strong> - Anda akan diminta untuk menambahkan file yang relevan untuk platform spesifik Anda (FT atau FMx).</li> <li><strong>Tambahkan perangkat</strong> - Cukup pindahkan perangkat Anda ke dalam grup perangkat. Platform akan menangani sisanya, memastikan setiap unit tetap terupdate.</li></ol></section>",
                "10": "<section><p>Mohon diperhatikan bahwa kami sedang memperbarui alamat email yang digunakan oleh <strong>FOTA WEB</strong> untuk mengirimkan pemberitahuan sistem otomatis. Mulai <strong>24 Maret 2026</strong>, semua korespondensi yang dihasilkan sistem akan beralih ke domain baru.</p></section><section><h3>Apa yang berubah?</h3></section><section><p>Kami beralih dari alamat pengirim lama ke alamat yang lebih ringkas:</p><ul><li><strong>Alamat lama:</strong> no-reply-fota@teltonika-iot-group.com</li><li><strong>Alamat baru:</strong> fota@teltonika-telematics.com</li></ul></section><section><h3>Apa yang harus Anda lakukan?</h3></section><section><p>Untuk memastikan Anda tidak melewatkan kode keamanan penting atau pembaruan sistem, kami merekomendasikan hal berikut:</p><ol><li><strong>Tambahkan alamat baru ke daftar aman</strong> - Tambahkan fota@teltonika-telematics.com ke daftar pengirim aman Anda atau hubungi departemen TI Anda untuk memastikan domain baru diizinkan oleh firewall organisasi Anda.</li><li><strong>Perbarui aturan filter</strong> - Jika Anda memiliki aturan folder otomatis atau label yang diatur di kotak masuk Anda untuk FOTA WEB, silakan perbarui aturan tersebut untuk menyertakan alamat baru.</li></ol></section><section><p>Email yang dikirim sebelum 24 Maret masih akan muncul dari alamat lama. Tidak diperlukan tindakan apa pun untuk korespondensi sebelumnya.</p></section>",
                "11": "<section><p>Mulai <strong>9 April 2026</strong>, kami meningkatkan protokol keamanan kami untuk memastikan akun Anda tetap aman. Kami tidak lagi menggunakan reset kata sandi sebagai cadangan untuk Otentikasi Dua Faktor (2FA) dan memperkenalkan <strong>Kode Pemulihan</strong> sebagai \"kunci cadangan\" baru Anda yang aman.</p></section> <section><h3>Apa yang berubah?</h3></section> <section><p>Sebelumnya, reset kata sandi dapat digunakan untuk melewati perangkat 2FA yang hilang. Untuk sejalan dengan praktik terbaik keamanan global, jalan pintas ini akan dihentikan.</p> <p><strong>Setelah perubahan ini, kode pemulihan akan menjadi satu-satunya cara untuk mendapatkan kembali akses ke akun Anda jika Anda kehilangan perangkat 2FA Anda.</strong></p> <p><strong>Catatan</strong>: Perubahan ini hanya berlaku bagi pengguna yang menggunakan <strong>Aplikasi Otentikasi</strong>. Jika Anda menggunakan opsi email untuk 2FA, proses Anda tetap sama, dan Anda tidak memerlukan kode pemulihan.</p></section> <section><h3>Bagaimana cara bersiap (lakukan sekarang!)</h3></section> <section><p>Jangan tunggu sampai Anda terkunci. Anda dapat membuat daftar kode pemulihan hari ini:</p> <ol><li>Buka <strong>Pengaturan</strong> -> <strong>Keamanan</strong>.</li> <li>Di bawah <strong>Buat kode pemulihan</strong>, tekan tombol <strong>Buat</strong>.</li> <li>Anda akan diminta memasukkan <strong>OTP (Kata Sandi Sekali Pakai)</strong> dari aplikasi otentikator Anda saat ini untuk memverifikasi identitas Anda.</li> <li><strong>Simpan kode-kode ini segera.</strong> Kode-kode ini hanya akan ditampilkan sekali demi keamanan Anda. Cetak, tulis, atau simpan kode-kode tersebut di pengelola kata sandi yang aman.</li></ol> <p><strong>Catatan</strong>: Membuat daftar kode baru akan secara otomatis membatalkan kode-kode lama.</p></section> <section><h3>Cara kerja pemulihan</h3></section> <section><p>Jika Anda kehilangan ponsel atau menghapus aplikasi otentikator, berikut cara untuk masuk kembali:</p> <ol><li><strong>Masuk</strong> - Masukkan email dan kata sandi standar Anda.</li> <li><strong>Prompt 2FA</strong> - Saat diminta memasukkan kode, klik <strong>\"Gunakan kode pemulihan\"</strong>.</li> <li><strong>Otentikasi</strong> - Masukkan salah satu kode pemulihan yang belum digunakan.</li> <li><strong>Reset</strong> - Setelah digunakan, 2FA Anda akan dinonaktifkan secara otomatis agar Anda dapat masuk kembali.</li> <li><strong>Atur ulang</strong> - Anda harus segera mengatur metode 2FA baru.</li> <li><strong>Kode baru</strong> - Daftar kode pemulihan lama Anda akan menjadi tidak valid, jadi pastikan untuk menyimpan daftar baru setelah 2FA baru Anda aktif.</li></ol></section>",
                "12": "",
                "13": ""
            },
            "title": {
                "1": "2FA wajib bagi pengguna baru mulai 7 Januari 2025",
                "2": "Pemeliharaan terjadwal pada 3 Juni 2025",
                "3": "Pembaruan Fitur Baru: Pembukaan Kunci Perangkat yang Lebih Mudah untuk Semua Pengguna",
                "4": "Temukan Fitur Baru di Dasbor Anda!",
                "5": "Penting: Perubahan API yang Akan Datang dan Sekilas tentang Peran dan Izin",
                "6": "Fitur Baru Kini Tersedia: Kontrol yang Lebih Baik dengan \"Peran dan Izin\"",
                "7": "Fitur Baru: Fleksibilitas Lebih Besar dengan Jadwal Tugas Berdasarkan Tanggal",
                "8": "Pembaruan Keamanan: Kontrol Siklus Hidup Penuh untuk Akses Pengguna",
                "9": "Pembaruan Fitur: Grup Perangkat Cerdas Terpadu untuk Platform FT dan FMx",
                "10": "Perubahan yang Akan Datang: Alamat Pengirim Baru untuk Email FOTA WEB",
                "11": "Pembaruan Keamanan: Memperkuat Pertahanan 2FA Anda",
                "12": "",
                "13": ""
            }
        },
        "published": "Dipublikasikan pada",
        "take me there": "Bawa saya ke sana",
        "tasks": {
            "current": "Saat ini",
            "status": {
                "completed": "Selesai",
                "completed_with_errors": "Selesai dengan kesalahan",
                "failed": "Gagal",
                "no tasks": "Tidak ada tugas"
            },
            "task_type_counts_7_days": {
                "progressBarTitle": "7 hari",
                "tooltipTitle": "7 hari terakhir"
            },
            "task_type_counts_30_days": {
                "progressBarTitle": "30 hari",
                "tooltipTitle": "30 hari terakhir"
            },
            "task_type_counts_90_days": {
                "progressBarTitle": "90 hari",
                "tooltipTitle": "90 hari terakhir"
            }
        },
        "title": {
            "activated": "Perangkat yang diaktifkan",
            "configurations": "Konfigurasi",
            "device status": "Status Perangkat",
            "firmware versions": "Versi firmware",
            "imported": "Perangkat yang diimpor",
            "news": "Berita",
            "queued tasks": "Tugas yang sedang antre",
            "refreshed every hour": "diperbarui setiap jam",
            "resource limits": "Batas sumber daya",
            "task overview": "Ringkasan tugas",
            "tasks": "Tugas"
        },
        "tooltips": {
            "activated": "Jumlah perangkat yang terhubung ke FOTA WEB untuk pertama kalinya selama periode yang dipilih (Hari Ini, 7 Hari Terakhir, 30 Hari Terakhir, 90 Hari Terakhir).",
            "configurations": "Menampilkan distribusi nama file konfigurasi yang telah diunggah ke perangkat Anda. Hingga 100 nama file unik ditampilkan.",
            "firmware versions": "Menampilkan distribusi versi firmware yang dilaporkan oleh perangkat yang terhubung. Hingga 100 versi unik ditampilkan.",
            "imported": "Jumlah perangkat yang ditambahkan ke akun Anda selama periode yang dipilih (Hari Ini, 7 Hari Terakhir, 30 Hari Terakhir, 90 Hari Terakhir)."
        }
    },
    "Date picker": {
        "disableFuture": "Tanggal tidak valid",
        "disablePast": "Tanggal tidak valid",
        "invalidDate": "Tanggal tidak valid",
        "maxDate": "Tanggal salah",
        "minDate": "Tanggal salah",
        "shouldDisableDate": "Tanggal tidak valid",
        "shouldDisableMonth": "Tanggal tidak valid",
        "shouldDisableYear": "Tanggal tidak valid"
    },
    "Device export": {
        "properties": {
            "activity_status": "Status",
            "bootloader": "Bootloader",
            "company_name": "Perusahaan",
            "created_at": "Dibuat pada",
            "current_configuration": "Konfigurasi",
            "current_firmware": "Firmware",
            "description": "Deskripsi",
            "group_name": "Grup",
            "gsm_number": "Nomor GSM",
            "iccid": "ICCID",
            "imei": "IMEI",
            "imsi": "IMSI",
            "model": "Model",
            "model_platform": "Platform",
            "modem_version": "Versi modem",
            "oem_file_vehicle_name": "",
            "product_code": "Kode produk",
            "seen_at": "Dilihat di",
            "serial": "Nomor Seri",
            "task_queue": "Antrian",
            "updated_at": "Diperbarui pada",
            "vin": "VIN"
        },
        "select data": "Pilih data"
    },
    "Dialog": {
        "access group inheritance": "",
        "add new device": "Tambahkan perangkat baru",
        "add new device description": "Tambahkan satu atau beberapa perangkat baru ke perusahaan dan grup yang dipilih. Hanya perangkat lama, seperti FM atau FMA, yang harus diimpor dengan mencentang kotak centang \"Impor sebagai perangkat lama\".",
        "add new device legacy title": "Impor sebagai perangkat lama.",
        "add new device legacy description": "Atur \"Dibuat pada\" menjadi 2016.01.01 dan \"Model\" menjadi Legacy.",
        "add new product code": "Tambahkan kode produk baru",
        "add new product code description": "Tambahkan kode produk perangkat baru dan hubungkan ke paket CAN yang tersedia.",
        "all permissions": "Semua izin",
        "assign access group": "",
        "assign can package description": "Pilih jenis paket dan terapkan ke semua perangkat yang dipilih.",
        "assign role": "Tetapkan peran",
        "attribute value": "Nilai atribut",
        "auto sync": "",
        "auto sync toggle": {
            "compatibility": {
                "compatible devices": "",
                "selected devices": ""
            },
            "descriptions": {
                "dialog": "",
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "modes": {
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "tooltips": {
                "bluetooth_auth_list_sync": "",
                "disabled submit": "",
                "main_configuration_sync": "",
                "manual_geofence_list_sync": "",
                "one_wire_auth_list_sync": ""
            }
        },
        "begin download": "Mulai unduh",
        "by date": "Berdasarkan tanggal",
        "by time": "Berdasarkan waktu",
        "can adapter": "Adaptor CAN",
        "cancel pending tasks": "Batalkan tugas yang tertunda dengan jenis tugas yang sama",
        "cancel tasks": "Batalkan tugas",
        "cancel tasks in group": {
            "alert title": "Proses ini akan memakan waktu hingga beberapa menit untuk diselesaikan.",
            "banner description": "Untuk melihat status terbaru dari tugas-tugas, silakan lihat detail grup tugas atau segarkan halaman.",
            "banner title": "Proses ini akan memakan waktu hingga beberapa menit untuk diselesaikan, tergantung pada jumlah tugas.",
            "description": "Mengklik \"Setuju\" akan membatalkan semua tugas yang tertunda dan sedang berjalan. Apakah Anda yakin ingin melanjutkan?",
            "title": "Batalkan semua tugas dalam grup?"
        },
        "canObd": "CAN/OBD",
        "carrier": "Carrier",
        "clear device history banner": "",
        "client email": "Alamat email perwakilan klien",
        "companies": "Perusahaan",
        "company": "Perusahaan",
        "company level": {
            "Basic": "Dasar",
            "Internal": "Internal",
            "Premium": "Premium",
            "Standard": "Standar"
        },
        "company level change description": "Tingkatkan level perusahaan dengan memilih level baru dan memberikan penjelasan alasannya. Penurunan level perusahaan tidak dimungkinkan. Semua tanggal menggunakan zona waktu UTC.",
        "company level manual revert": {
            "confirmation": {
                "description": "Tindakan ini akan mengembalikan tingkat perusahaan ke tingkat yang ditetapkan secara otomatis, yaitu \"{{companyLevel}}\". Apakah Anda yakin ingin melanjutkan?",
                "title": "Kembalikan perubahan level manual?"
            },
            "description": "Mengembalikan pengaturan akan mengubah tingkat perusahaan kembali ke tingkat yang ditetapkan secara otomatis.",
            "title": "Tingkat layanan perusahaan ini telah ditingkatkan secara manual hingga {{expirationDate}}."
        },
        "company level type": "Jenis tingkat perusahaan",
        "company name": "Nama perusahaan",
        "company statistics": {
            "child companies": "Jumlah anak perusahaan",
            "devices": "Jumlah perangkat",
            "files": "Jumlah file",
            "groups": "Jumlah grup perangkat",
            "tasks": "Jumlah tugas",
            "users": "Jumlah pengguna"
        },
        "company type": {
            "All": "",
            "Client": "Klien",
            "Internal": "Internal",
            "Virtual": "Virtual"
        },
        "configuration": "Konfigurasi",
        "confirmations": {
            "are you sure": "Apakah Anda yakin?",
            "are you sure you wish to continue": "Apakah Anda yakin ingin melanjutkan?",
            "assign can package confirmation": "Apakah Anda yakin ingin menetapkan paket yang dipilih ke sejumlah perangkat yang ditentukan?",
            "cancel task confirmation": {
                "first part": "Apakah Anda yakin ingin membatalkan sejumlah tugas yang ditentukan?",
                "second part": "Jika demikian, masukkan jumlah tugas yang terpengaruh dan klik \"Konfirmasi\"."
            },
            "create task confirmation": "Apakah Anda yakin ingin membuat tugas untuk jumlah perangkat yang ditentukan?",
            "delete resource confirmation": {
                "first part": "Apakah Anda yakin ingin menghapus sejumlah {{resource}} yang ditentukan?",
                "second part": "Jika demikian, masukkan jumlah {{resource}} yang terpengaruh dan klik \"Hapus\"."
            },
            "delete resources": {
                "companies": "perusahaan",
                "files": "file",
                "groups": "kelompok perangkat",
                "deviceModels": "model",
                "productCodes": "kode produk",
                "roles": "peran",
                "users": "pengguna"
            },
            "description second part": "Jika demikian, masukkan jumlah perangkat yang terpengaruh dan klik \"Konfirmasi\".",
            "export device data confirmation": "Apakah Anda yakin ingin mengekspor data perangkat untuk jumlah perangkat yang ditentukan?",
            "file": "Masukkan jumlah baris yang ada dalam file",
            "filter": {
                "companies": "Masukkan jumlah perusahaan yang disaring",
                "devices": "Masukkan jumlah perangkat yang difilter",
                "files": "Masukkan jumlah file yang difilter",
                "groups": "Masukkan jumlah grup perangkat yang difilter",
                "productCodes": "Masukkan jumlah kode produk yang difilter",
                "tasks": "Masukkan jumlah tugas yang difilter",
                "users": "Masukkan jumlah pengguna yang difilter"
            },
            "id_list": {
                "companies": "Masukkan jumlah perusahaan yang dipilih",
                "devices": "Masukkan jumlah perangkat yang dipilih",
                "files": "Masukkan jumlah file yang dipilih",
                "groups": "Masukkan jumlah grup perangkat yang dipilih",
                "productCodes": "Masukkan jumlah kode produk yang dipilih",
                "tasks": "Masukkan jumlah tugas yang dipilih",
                "users": "Masukkan jumlah pengguna yang dipilih"
            },
            "merge companies confirmation": "Anda akan menggabungkan perusahaan {{sourceCompany}} dan {{targetCompany}}.",
            "move companies confirmation": "Anda akan segera memindahkan {{sourceCompany}} ke perusahaan {{targetCompany}}.",
            "move devices confirmation": "Apakah Anda yakin ingin memindahkan sejumlah perangkat yang ditentukan ke perusahaan lain?",
            "number of lines": "Jumlah baris",
            "selected 20 or more devices": "Anda telah memilih 20 perangkat atau lebih...",
            "transfer devices confirmation": "Apakah Anda yakin ingin memindahkan sejumlah perangkat yang ditentukan ke perusahaan lain?"
        },
        "confirm cannot revert": "Tindakan ini tidak dapat dibatalkan.",
        "confirm merge companies": "Apakah Anda yakin ingin menggabungkan perusahaan-perusahaan ini?",
        "count": "Jumlah",
        "create company": "Buat perusahaan",
        "create company description": "Buat perusahaan baru di bawah perusahaan induk yang dipilih.",
        "create desktop license": "Buat lisensi desktop",
        "create desktop license description": "Terbitkan lisensi FOTA Desktop online baru untuk perusahaan klien dengan alamat IP, kunci perangkat keras, dan masa berlaku (maksimal 2 tahun).",
        "create group": "Buat grup",
        "create group description": "Atur perangkat ke dalam grup untuk memudahkan pengelolaan dan penugasan massal.",
        "create model": "Buat model",
        "create model description": "Buat model perangkat baru dengan menentukan nama, platform, dan dukungan TCT web.",
        "create offline license": "Buat lisensi offline",
        "create or edit group description": "Firmware dan konfigurasi dapat ditugaskan ke grup. Setelah ini dilakukan, tugas pembaruan firmware dan/atau konfigurasi akan dihasilkan untuk semua anggota grup (perangkat).",
        "create role": "Buat peran",
        "create role description": "Buat peran baru dengan memberikan nama dan deskripsi, memilih perusahaan, dan menetapkan izin tertentu.",
        "create smart group": "Buat Grup Cerdas",
        "create smart group banner message": "Perubahan pada file akan membatalkan semua tugas yang tertunda sebelumnya dengan jenis yang sama.",
        "create smart group description": "File firmware dan konfigurasi dapat ditugaskan ke grup untuk setiap platform. Setelah file ditugaskan, tugas pembaruan akan dihasilkan untuk semua perangkat dalam grup.",
        "create task description first step": "Buat berbagai macam tugas, mulai dari memperbarui konfigurasi atau firmware hingga menerima log, konfigurasi, dan lainnya dari perangkat yang dipilih atau difilter. Selain itu, Anda dapat menjadwalkan tugas yang telah dibuat untuk kenyamanan Anda.",
        "create task description last step": "Pastikan informasi di bawah ini benar sebelum membuat tugas.",
        "current level": "tingkat saat ini",
        "custom resource limits": {
            "at least one limit must be higher": "Setidaknya satu batas harus lebih tinggi dari nilai default tingkat Premium.",
            "configuration files per device": "Berkas konfigurasi per perangkat",
            "confirmation modal description": "Apakah Anda yakin ingin mengubah batas sumber daya berikut untuk perusahaan \"{{companyName}}\"?",
            "confirmation modal title": "Mengubah batas sumber daya perusahaan?",
            "count": {
                "companies count": "Jumlah perusahaan: {{number}}",
                "configuration files per device count": "Jumlah berkas konfigurasi per perangkat: {{number}}",
                "tasks per group count": "Jumlah tugas per grup: {{number}}",
                "users count": "Jumlah pengguna: {{number}}"
            },
            "explanations": {
                "companies": "Jumlah total anak perusahaan yang dapat dibuat dalam hierarki perusahaan.",
                "configuration files per device": "Jumlah berkas konfigurasi yang dapat disimpan, 1 perangkat setara dengan 1 berkas konfigurasi. Jumlah minimum berkas konfigurasi yang dijamin adalah 100 untuk setiap tingkat perusahaan.",
                "tasks per group": "Jumlah tugas yang dapat ada dalam satu grup tugas.",
                "users": "Jumlah total pengguna yang dapat dibuat dalam hierarki perusahaan."
            },
            "main modal description": "Tentukan jumlah sumber daya kustom untuk berbagai jenis sumber daya seperti perusahaan, pengguna, tugas per grup tugas, atau berkas konfigurasi. Sumber daya kustom akan tetap aktif hingga masa berlaku tingkat Premium berakhir atau disetel ulang secara manual.",
            "resources limit type": "Jenis batasan sumber daya",
            "revert custom resource limits": "Kembalikan batas sumber daya khusus",
            "revert custom resource limits description": "Mengatur ulang semua batas akan mengembalikan nilai sumber daya ke nilai default dan mengubah tingkat perusahaan menjadi Premium.",
            "revert custom resource limits description confirmation": "Tindakan ini akan mengembalikan batas sumber daya ke batas yang ditetapkan secara otomatis untuk tingkat \"Premium\". Apakah Anda yakin ingin melanjutkan?",
            "revert custom resource limits title": "Batas sumber daya perusahaan ini ditetapkan secara manual.",
            "revert custom resource limits title confirmation": "Mengembalikan batas sumber daya khusus?",
            "tasks per group": "Tugas per grup"
        },
        "date range": "Rentang tanggal",
        "date to": "ke",
        "delete companies": "Hapus perusahaan",
        "delete deviceModels": "Hapus model",
        "delete files": "Hapus file",
        "delete file warning": "Menghapus file akan membatalkan tugas dan grup tugas yang terkait.",
        "delete groups": "Hapus grup perangkat",
        "delete productCodes": "Hapus kode produk",
        "delete roles": "Hapus peran",
        "delete tasks and history": "",
        "delete users": "Hapus pengguna",
        "description": "Deskripsi",
        "desktop license delete description": "Apakah Anda yakin ingin menghapus lisensi desktop \"{{name}}\"?",
        "desktop license name": "Nama lisensi desktop",
        "device identifier": "Pengidentifikasi perangkat",
        "device transfer": {
            "main": {
                "description": "Pindahkan perangkat yang dipilih atau disaring ke perusahaan lain menggunakan token yang dihasilkan oleh perusahaan penerima.",
                "title": "Transfer perangkat"
            },
            "receive devices": {
                "copy token": "Salin dan kirimkan token yang dihasilkan kepada orang yang bertanggung jawab atas pemindahan perangkat dari perusahaan mereka ke perusahaan Anda.",
                "description": "Buat token perangkat penerima dan kirimkan ke perusahaan pengirim.",
                "token info": "Token ini hanya dapat digunakan sekali dan akan kedaluwarsa setelah 21 hari."
            },
            "transfer devices": {
                "confirmation": "Apakah Anda yakin ingin memindahkan perangkat ke perusahaan di bawah ini?",
                "device token": "Token transfer perangkat harus diperoleh dari manajer perusahaan yang ingin Anda tuju untuk mentransfer perangkat Anda.",
                "transfer from file": "Unggah file yang berisi daftar perangkat (IMEI) yang ingin Anda pindahkan dari perusahaan Anda ke perusahaan yang tokennya baru saja Anda masukkan."
            }
        },
        "device transfer token": "Token transfer perangkat",
        "downgrading company level is not possible": "Penurunan tingkat perusahaan tidak dimungkinkan",
        "download sample file message": "Unduh <1>contoh templat CSV</1> untuk melihat contoh format yang diperlukan.",
        "edit group banner message": "Mengubah firmware dan/atau berkas konfigurasi akan membatalkan semua tugas yang tertunda sebelumnya dengan jenis yang sama.",
        "edit group description": "Ubah pengaturan untuk grup perangkat ini.",
        "edit role description": "Sesuaikan nama, deskripsi, dan izin peran. Perusahaan yang ditugaskan tidak dapat diubah.",
        "edit smart group description": "Berkas firmware dan konfigurasi dapat ditugaskan atau diubah untuk grup pada setiap platform. Setelah berkas ditugaskan atau diubah, tugas pembaruan akan dihasilkan untuk semua perangkat dalam grup.",
        "email": "Email",
        "enter": "Masuk",
        "enter code": "Masukkan kode",
        "enter description": "Masukkan deskripsi",
        "enter name": "Masukkan nama",
        "example": "Contoh:",
        "expires at": "Berlaku hingga",
        "explanation": "Penjelasan",
        "export device data": "Ekspor data perangkat",
        "export device description": "Ekspor data untuk perangkat yang dipilih atau difilter ke format file .csv atau .xlsx.",
        "export file format": "Format file ekspor",
        "feature": "Fitur",
        "feature control": "Kontrol fitur",
        "field disabled until company selected": "Kolom ini dinonaktifkan hingga Perusahaan dipilih.",
        "firmware": "Firmware",
        "files to download": "File untuk diunduh",
        "file upload": {
            "banner text": {
                "1_wire_authorization_list": "Daftar otorisasi 1-Wire yang diunggah akan secara otomatis diurutkan untuk meningkatkan kecepatan dan akurasi fungsi.",
                "bluetooth_authorization_list": "Daftar otorisasi Bluetooth yang diunggah akan secara otomatis diurutkan untuk meningkatkan kecepatan dan akurasi fungsi."
            },
            "endings": {
                "file": "file",
                "files": "file"
            },
            "fail": {
                "multiple": "{{failCount}} dari {{totalCount}} berkas dengan ekstensi {{fileEnding}} tidak berhasil diunggah karena terjadi kesalahan.",
                "single": "{{failCount}} dari {{totalCount}} berkas dengan ekstensi {{fileEnding}} tidak berhasil diunggah karena terjadi kesalahan."
            },
            "success": {
                "multiple": "Semua file telah berhasil ditambahkan ke perusahaan yang dipilih.",
                "single": "Semua file telah berhasil ditambahkan ke perusahaan yang dipilih."
            }
        },
        "filtered": "Disaring",
        "filtered companies": "Perusahaan yang disaring",
        "filtered devices": "Perangkat yang difilter",
        "filtered files": "File yang difilter",
        "filtered groups": "Grup yang difilter",
        "filtered tasks": "Tugas yang difilter",
        "filtered users": "Pengguna yang difilter",
        "find tool": {
            "device": {
                "error not valid": "IMEI harus terdiri dari 15 karakter",
                "error subtitle": "Perangkat tidak ditemukan. Silakan coba masukkan IMEI yang berbeda.",
                "error title": "Tidak ditemukan perangkat",
                "link": "Buka perangkat",
                "no permission": "Anda tidak memiliki izin untuk melihat perangkat ini."
            },
            "user": {
                "error not valid": "Format email tidak valid",
                "error subtitle": "Pengguna tidak ditemukan. Silakan coba masukkan alamat email pengguna yang berbeda.",
                "error title": "Tidak ditemukan pengguna",
                "link": "Buka halaman pengguna",
                "no permission": "Anda tidak memiliki izin untuk melihat pengguna ini."
            }
        },
        "firmware date": "Tanggal firmware",
        "from form": "Dari formulir",
        "from file": "Dari file",
        "general": "Umum",
        "gsm_number": "Nomor GSM",
        "iccid": "ICCID",
        "imei": "IMEI",
        "imei restriction": "Pembatasan IMEI",
        "import device data": "Impor data perangkat",
        "import device data description": "Impor data atribut yang dipilih untuk perangkat dalam daftar yang disediakan.",
        "import device data info": "Setiap atribut memiliki batas karakter maksimum yang ditampilkan dalam tanda kurung. Jika suatu atribut memiliki karakter lebih banyak dari batas maksimum, maka atribut tersebut akan secara otomatis dipersingkat hingga batas maksimum.",
        "import device data limit": "(maks. {{limit}} karakter)",
        "imsi": "IMSI",
        "input text too long": "Teks terlalu panjang. Maksimal {{maxLength}} karakter diperbolehkan.",
        "invalid hardware key": "Format kunci perangkat keras tidak valid",
        "invalid imei": "IMEI tidak valid",
        "invalid ipv4": "Format IPv4 tidak valid",
        "invalid serial": "Nomor seri tidak valid",
        "invalid value": "Nilai tidak valid",
        "inverted selection": "Pemilihan terbalik",
        "invite user": "Undang pengguna",
        "invite user description": "Undang pengguna baru ke perusahaan induk yang dipilih dan tentukan peran mereka. Setelah undangan dikirim, pengguna memiliki waktu 30 hari untuk menerimanya sebelum undangan tersebut kadaluwarsa.",
        "invite user max roles": "Maksimal 5 peran diperbolehkan. Hapus pilihan salah satunya untuk melanjutkan.",
        "log files": "File log",
        "make": "Buat",
        "manage permissions": "Kelola semua data tingkat akun dan situs.",
        "maximum value is": "Nilai maksimum adalah {{value}}",
        "merge companies": "Penggabungan perusahaan",
        "merge companies info": "Semua sumber daya perusahaan asal (Perangkat, Grup, File, Perusahaan, Pengguna beserta Peran mereka) akan dipindahkan ke perusahaan tujuan. Anda mungkin ingin meninjau peran pengguna sebelum penggabungan. Perusahaan asal akan dihapus setelahnya.",
        "merge companies disabled option": {
            "client to internal": "Perusahaan jenis klien tidak dapat digabungkan ke dalam perusahaan jenis internal.",
            "internal": "Perusahaan jenis internal tidak dapat digabungkan.",
            "lz code": "Perusahaan dengan kode tidak dapat digabungkan."
        },
        "minimum value is": "Nilai minimum adalah {{value}}",
        "move companies disabled option": {
            "internal": "Perusahaan jenis internal tidak dapat dipindahkan."
        },
        "move device": "Pindahkan perangkat",
        "move device description": "Pindahkan perangkat yang dipilih atau difilter ke perusahaan yang sudah ada dan/atau grup dalam hierarki perusahaan.",
        "move device group": "Pindahkan grup perangkat",
        "move device group banner": "Memindahkan grup perangkat yang dipilih ke perusahaan lain akan secara otomatis memigrasikan perangkat yang terkait dengannya.",
        "move device group description": "Pindahkan grup perangkat yang dipilih ke perusahaan yang dipilih.",
        "move devices": "Pindahkan perangkat",
        "name": "Nama",
        "newest": "Dari yang terbaru",
        "no dropdown files": {
            "description": "Untuk memilih opsi ini, unggah file baru $t(Dialog##no dropdown files##file names##{{fileName}}).",
            "description no permission create file": "",
            "file names": {
                "1_wire_authorization_list": "Daftar otorisasi 1-Wire",
                "adas_firmware": "Firmware ADAS",
                "ble_fw": "Firmware BLE",
                "blue_nrg": "Firmware BlueNrg",
                "bluetooth_authorization_list": "Daftar otorisasi Bluetooth",
                "can_chip_firmware": "Firmware chip FM CAN",
                "carrier_advance_firmware": "Firmware Carrier Advance",
                "carrier_advance_settings": "Carrier Advance pengaturan",
                "carrier_apx_firmware": "Firmware Carrier APX",
                "carrier_apx_settings": "Pengaturan Carrier APX",
                "certificate": "Sertifikat TLS",
                "configuration": "konfigurasi",
                "dsm_firmware": "Firmware DSM",
                "dtb": "DTB",
                "firmware": "firmware",
                "fw_bundle": "paket firmware",
                "gnssm_download_assistant": "Asisten Unduh GNSS-M",
                "gnssm_firmware": "Firmware GNSS-M",
                "main configuration": "",
                "manual_geofence_list": "Daftar skenario geofence manual",
                "meig_modem_firmware": "Firmware modem MeiG",
                "netprisma_modem_firmware": "Firmware modem NETPRISMA",
                "psub": "langganan",
                "quectel_modem_firmware": "Firmware modem Quectel",
                "simcom_modem_firmware": ""
            },
            "main": "Tidak ada file $t(Dialog##no dropdown files##file names##{{fileName}})."
        },
        "none": "Tidak ada",
        "obd oem": "OBD OEM",
        "offline license delete description": "Apakah Anda yakin ingin menghapus lisensi offline \"{{name}}\"?",
        "oldest": "Dari yang tertua",
        "only integers": "Hanya angka bulat yang valid",
        "only numbers": "Hanya angka yang valid",
        "optional": "opsional",
        "other companies": "Perusahaan lain",
        "parent company": "Perusahaan induk",
        "permission preset": "Pengaturan izin default",
        "platform compatibility": {
            "banner text": "Beberapa model perangkat yang dipilih tidak kompatibel dengan jenis tugas yang dipilih. Jenis tugas ini tidak akan dibuat secara default untuk model perangkat yang tidak kompatibel.",
            "compatible model devices": "Perangkat model yang kompatibel",
            "count text": "Tugas akan dibuat untuk <1>{{compatibleCount}}</1> dari {{totalCount}} perangkat.",
            "create tasks for incompatible devices": "Buat tugas untuk perangkat yang tidak kompatibel.",
            "devices from file": "Perangkat dari file",
            "platform": "Platform {{title}}",
            "task applies": "Tugas ini berlaku untuk",
            "task cannot be created": "Tugas tidak dapat dibuat untuk perangkat dengan model yang tidak kompatibel."
        },
        "receiving company": "Perusahaan ini akan menerima perangkat Anda",
        "resend user invitation": "Kirim ulang undangan pengguna",
        "retry tasks in group": {
            "alert title": "Proses ini akan memakan waktu hingga beberapa menit untuk diselesaikan.",
            "banner description": "Untuk melihat status terbaru dari tugas-tugas, silakan lihat detail grup tugas atau segarkan halaman.",
            "description": "Dengan menekan \"Setuju\", semua tugas yang gagal akan dicoba ulang. Apakah Anda yakin ingin melanjutkan?",
            "title": "Apakah ingin mencoba ulang semua tugas dalam grup?"
        },
        "revision": "Revisi",
        "revision value error": "Nilai harus terdiri dari dua digit (00 - 99).",
        "role name": "Nama peran",
        "root company": "Perusahaan induk",
        "sales email": "Alamat email manajer penjualan",
        "scheduled time warning": "Tugas dengan waktu terjadwal tidak mengubah konfigurasi waktu koneksi FOTA perangkat. Tugas akan dijalankan jika perangkat terhubung ke FOTA selama jendela waktu yang dipilih. Pastikan perangkat dikonfigurasi untuk terhubung ke FOTA WEB pada interval yang tidak kurang dari jendela waktu yang dipilih.",
        "schedule task": "Jadwalkan tugas",
        "select": "Pilih",
        "select at least one": {
            "companies": "Silakan pilih setidaknya satu perusahaan",
            "devices": "Silakan pilih setidaknya satu perangkat",
            "files": "Silakan pilih setidaknya satu file",
            "groups": "Silakan pilih setidaknya satu grup",
            "tasks": "Silakan pilih setidaknya satu tugas",
            "users": "Silakan pilih setidaknya satu pengguna"
        },
        "selected": "Dipilih",
        "selected companies": "Perusahaan terpilih",
        "selected deviceModels": "Model terpilih",
        "selected devices": "Perangkat yang dipilih",
        "selected files": "File yang dipilih",
        "selected groups": "Kelompok perangkat yang dipilih",
        "selected productCodes": "Kode produk yang dipilih",
        "selected roles": "Peran yang dipilih",
        "selected tasks": "Tugas yang dipilih",
        "selected users": "Pengguna terpilih",
        "select company": "Pilih perusahaan",
        "select group": "Pilih grup",
        "select time interval": "Pilih interval waktu",
        "selected time window": "Jendela waktu yang dipilih: {{fromDate}} hingga {{toDate}}",
        "set bluetooth password": {
            "bluetooth password": "",
            "repeat bluetooth password": "",
            "enter password": "",
            "password source": "",
            "rules": {
                "allowed characters": "",
                "characters length": "",
                "passwords must match": ""
            },
            "SystemGenerated": {
                "description": ""
            },
            "UserEntered": {
                "description": ""
            }
        },
        "show files for selected companies only": "Tampilkan file hanya untuk perusahaan yang dipilih",
        "smart group": {
            "description": "Pilih file yang tersedia untuk perangkat platform {{platformName}}.",
            "title": "Berkas platform {{platformName}}"
        },
        "sn": "Nomor Seri",
        "specific": "Spesifik",
        "time period": "Periode waktu",
        "time period custom": "Sesuai pesanan",
        "tls certificate transfer info": "Tingkat keamanan saluran komunikasi FOTA WEB tidak sesuai dengan persyaratan transfer sertifikat aman TLS. Gunakan dengan hati-hati.",
        "token has expired": "Token telah kadaluwarsa",
        "token is valid": "Token ini masih berlaku",
        "transfer companies": "Perusahaan transfer",
        "transfer companies description": "Pilih apakah akan memindahkan atau menggabungkan dua perusahaan. Beberapa opsi tidak dapat dibatalkan.",
        "transfer devices": "Transfer perangkat",
        "tri source": {
            "selected tab description": {
                "create task": "Tugas yang dipilih akan dibuat untuk perangkat yang dipilih menggunakan kotak centang.",
                "general": "Tindakan yang dipilih akan dijalankan pada perangkat yang dipilih menggunakan kotak centang."
            },
            "filtered tab description": {
                "create task": "Tugas yang dipilih akan dibuat untuk perangkat yang difilter menggunakan satu atau lebih filter yang tersedia.",
                "general": "Tindakan yang dipilih akan dijalankan pada perangkat yang difilter menggunakan satu atau lebih filter yang tersedia."
            },
            "from file tab description": {
                "create task": "Tugas yang dipilih akan dibuat untuk perangkat yang tercantum dalam file yang diunggah.",
                "general": "Tindakan yang dipilih akan dijalankan pada perangkat yang tercantum dalam file yang diunggah."
            }
        },
        "unlocker": {
            "generate unlock key": "Buat kunci pembuka",
            "generate unlock key description": "Masukkan \"Kode Kunci\" perangkat dari TCT di kolom di bawah ini. Tekan tombol \"Generate\" untuk menghasilkan kunci pembuka, lalu gunakan kunci tersebut di TCT untuk membuka kunci perangkat Anda.",
            "invalid lock code": "Kode kunci perangkat tidak valid.",
            "limit reached": "Anda telah mencapai batas maksimum kunci pembuka yang dihasilkan.",
            "lock code": "Kode kunci",
            "unlock key": "Buka kunci",
            "unlock key success message": "Kunci telah berhasil dihasilkan."
        },
        "upload file": "Unggah file",
        "upload file description": "Unggah hingga {{count}} file sekaligus menggunakan bidang seret dan lepas atau dengan memilihnya.",
        "upload firmware bundle container info": "",
        "upload firmware downgrade protection info": "Versi firmware 04.00.00 ke atas dilengkapi dengan perlindungan terhadap downgrade. Untuk detail lebih lanjut mengenai perubahan firmware, silakan lihat dokumentasi kami di <1>Teltonika GPS Wiki</1>. Dengan menekan tombol \"Next\", Anda menyetujui dan memahami informasi di atas.",
        "upload firmware unsupported info": "Pembaruan ke versi ini tidak tersedia, silakan hubungi dukungan Teltonika atau manajer penjualan Teltonika Anda.",
        "use at least one filter": "Silakan gunakan setidaknya satu filter",
        "user": "Pengguna",
        "valid until": "Berlaku hingga",
        "valid until date disable description": "Kolom ini hanya dapat diubah jika Periode Waktu diatur ke \"Kustom\"",
        "vehicle model": "Model"
    },
    "Dropzone": {
        "add file": "Tambahkan file",
        "add files": "Tambahkan file",
        "drop file to upload": "Seret file untuk mengunggahnya",
        "drop files to upload": "Seret dan lepas file untuk mengunggah",
        "error uploading the file": "Terjadi kesalahan saat mengunggah file",
        "file invalid type": "Jenis file yang dipilih tidak valid.",
        "file successfully uploaded": "File berhasil diunggah",
        "file syntax": "Sintaks file adalah sebagai berikut:",
        "invalid format or size": "",
        "max file size": "",
        "maximum file limit reached": "Batas ukuran file maksimum telah tercapai.",
        "only one file can be attached": "Hanya satu file yang dapat dilampirkan.",
        "or drop file to upload": "Atau seret dan lepas file untuk mengunggah",
        "or drop files to upload": "Atau seret dan lepas file untuk mengunggahnya",
        "rows detected": "Baris dalam file berhasil terdeteksi",
        "select file": "Pilih file",
        "select files": "Pilih file",
        "select file type": "Silakan pilih jenis file terlebih dahulu.",
        "supported formats": "Format yang didukung",
        "too long file name": "Nama file terlalu panjang. Maksimal {{maxLength}} karakter diperbolehkan.",
        "too many files description": "Sisa file dapat diunggah setelah Anda mengunggah file yang dipilih.",
        "too many files title": "Ada batasan maksimum {{maxFiles}} file yang dapat Anda lampirkan sekaligus."
    },
    "Error": {
        "error": "Kesalahan",
        "message wait": "Mohon bersabar sampai kami memperbaiki kesalahan ini.",
        "title": "Terjadi kesalahan!"
    },
    "Feature highlight": {
        "got it": "Sudah paham",
        "new feature": "Fitur baru!",
        "scenarios description": "Sekarang, Anda dapat mengatur salah satu skenario berikut pada perangkat Anda: Melebihi Kecepatan, Deteksi Tabrakan, atau Deteksi Penarikan."
    },
    "Filter": {
        "access group": "",
        "activity_status": "Status",
        "all permissions": "Semua izin",
        "batch_id": "ID Batch",
        "company_id": "Perusahaan",
        "company selector": "",
        "configuration change origin": "",
        "configuration_file_id": "Konfigurasi",
        "configuration type": "",
        "created_by": "Dibuat oleh",
        "current_configuration": "Konfigurasi",
        "current_firmware": "Firmware",
        "device_imei": "Nomor IMEI perangkat",
        "file type": "Jenis file",
        "filtered by": "Disaring berdasarkan",
        "filters used": "Filter yang digunakan",
        "firmware_file_id": "FMx Firmware",
        "ft_bluetooth_auth_list_file_id": "",
        "ft_configuration_file_id": "",
        "ft_firmware_file_id": "FT firmware",
        "ft_one_wire_auth_list_file_id": "",
        "group_id": "Grup",
        "id": "ID",
        "Invalid company": "Perusahaan tidak valid",
        "model": "Model",
        "model_platform": "Platform",
        "Multiple companies": "Banyak perusahaan",
        "parent company": "Perusahaan induk",
        "permission": "Izin",
        "permission status": "Status",
        "role": "Peran",
        "spec_id": "Spec ID",
        "status_id": "Status",
        "supported_task_type": "Jenis tugas",
        "table filters": "Filter tabel",
        "task type": "Jenis tugas",
        "task_queue": "Antrian",
        "type": "Jenis",
        "user status": "Status"
    },
    "Flash": {
        "account was deleted": "",
        "ADAS firmware file size can't be zero": "Ukuran file firmware ADAS tidak boleh nol.",
        "ADAS firmware is invalid.": "Firmware ADAS tidak valid.",
        "All notifications were deleted.": "Semua pemberitahuan telah dihapus.",
        "All notifications were marked as read.": "Semua pemberitahuan telah ditandai sebagai telah dibaca.",
        "At least one user role must be provided.": "Setidaknya satu peran pengguna harus disediakan.",
        "Attributes length is invalid": "Panjang atribut tidak valid.",
        "Banner was updated.": "Banner telah diperbarui.",
        "Batch was discarded": "Batch telah dihapus.",
        "Bulk attribute update job was created. Devices' attributes will be updated shortly.": "Tugas pembaruan atribut massal telah dibuat. Atribut perangkat akan segera diperbarui.",
        "Bulk create job was created. Devices will be created shortly.": "Tugas pembuatan massal telah dibuat. Perangkat akan segera dibuat.",
        "Bulk create job was created. Tasks will be created shortly.": "Tugas pembuatan massal telah dibuat. Tugas-tugas akan segera dibuat.",
        "Bulk delete job was created. Companies will be removed shortly.": "Tugas penghapusan massal telah dibuat. Perusahaan-perusahaan akan dihapus dalam waktu dekat.",
        "Bulk delete job was created. Devices will be removed shortly.": "Tugas penghapusan massal telah dibuat. Perangkat akan dihapus dalam waktu dekat.",
        "Bulk delete job was created. Files will be removed shortly.": "Tugas penghapusan massal telah dibuat. File-file akan dihapus dalam waktu dekat.",
        "Bulk delete job was created. Groups will be removed shortly.": "Tugas penghapusan massal telah dibuat. Grup akan dihapus dalam waktu dekat.",
        "Bulk delete job was created. Product codes will be removed shortly.": "Tugas penghapusan massal telah dibuat. Kode produk akan dihapus dalam waktu dekat.",
        "Bulk delete job was created. Users will be removed shortly.": "Tugas penghapusan massal telah dibuat. Pengguna akan dihapus dalam waktu dekat.",
        "Bulk task create job was created. Tasks will be created shortly.": "Tugas massal telah dibuat dan tugas-tugas tersebut akan segera muncul. Tugas-tugas tersebut dapat ditemukan di halaman \"Kelompok Tugas\" di bawah detail kelompok tugas.",
        "Bulk update job was created. Devices will be updated shortly.": "Tugas pembaruan massal telah dibuat. Perangkat akan segera diperbarui.",
        "Bulk update job was created. Tasks will be updated shortly.": "Tugas pembaruan massal telah dibuat. Tugas-tugas akan segera diperbarui.",
        "Can adapter was added.": "Adaptor Can telah ditambahkan.",
        "Can adapter was deleted.": "Adaptor Can telah dihapus.",
        "Can adapter was updated.": "Adaptor Can telah diperbarui.",
        "Can chip firmware file size can't be zero": "Ukuran file firmware chip Can tidak boleh nol.",
        "Can chip firmware is invalid.": "Firmware chip Can mungkin tidak valid.",
        "Cannot delete company. Company is not empty.": "Tidak dapat menghapus perusahaan. Perusahaan tidak kosong.",
        "Cannot delete file. It is used by pending or running tasks.": "File tidak dapat dihapus. File tersebut digunakan untuk tugas yang sedang dalam antrean atau sedang berjalan.",
        "Cannot delete file. It is used by running tasks.": "File tidak dapat dihapus. File tersebut sedang digunakan oleh tugas yang sedang berjalan.",
        "Cannot delete file. There are tasks waiting for approval.": "",
        "Cannot delete product code assigned to devices.": "Tidak dapat menghapus kode produk yang telah ditetapkan ke perangkat.",
        "check your email for details": "",
        "Companies count limit exceeded.": "Batas jumlah perusahaan telah terlampaui.",
        "Companies in the request must belong to the selected root.": "Perusahaan yang tercantum dalam permintaan harus termasuk dalam akar yang dipilih.",
        "Company merge job was created. It will be merged shortly.": "Tugas penggabungan perusahaan telah dibuat. Proses penggabungan akan segera dilakukan.",
        "Company name already exist.": "Nama perusahaan tersebut sudah ada.",
        "Company level change is not allowed.": "Perubahan tingkat perusahaan tidak diperbolehkan.",
        "Company level successfully changed": "Perubahan tingkat perusahaan telah berhasil dilakukan.",
        "company level successfully reverted": "Tingkat perusahaan berhasil dikembalikan ke tingkat yang ditetapkan secara otomatis.",
        "Company not allowed to be merged": "Perusahaan tidak boleh digabungkan.",
        "company resource limits changed": "Batas sumber daya perusahaan telah berhasil diubah.",
        "Company was created.": "Perusahaan telah didirikan.",
        "Company was deleted.": "Perusahaan telah dihapus.",
        "Company was updated.": "Perusahaan telah diperbarui.",
        "compatibilities added": "{{count}} kompatibilitas baru ditambahkan selama sinkronisasi.",
        "compatibilities synchronized": "Kompatibilitas yang hilang telah berhasil disinkronkan.",
        "Configuration cannot have FOTA functionality disabled": "Fungsi FOTA tidak dapat dinonaktifkan dalam konfigurasi.",
        "Configuration file cannot contain duplicate parameters": "Berkas konfigurasi tidak boleh mengandung parameter yang sama.",
        "Configuration file size can't be zero": "Ukuran berkas konfigurasi tidak boleh nol.",
        "Configuration files count limit exceeded.": "Batas jumlah berkas konfigurasi terlampaui.",
        "Configuration version must be defined": "Versi konfigurasi harus ditentukan.",
        "custom resource limits successfully reverted": "Batas sumber daya khusus telah berhasil dikembalikan ke batas yang ditetapkan secara otomatis.",
        "Custom roles feature is not enabled.": "Fitur peran kustom hanya dapat digunakan oleh pengguna dengan tingkat perusahaan Premium. Peran kustom yang telah dibuat sebelumnya dapat dihapus.",
        "desktop license added": "Lisensi desktop \"{{name}}\" telah berhasil ditambahkan.",
        "Devices already are in target company": "Perangkat tersebut sudah ada di perusahaan tujuan.",
        "Device already exists.": "Perangkat sudah ada.",
        "Device bulk attribute update file cannot be empty": "Berkas pembaruan atribut massal perangkat tidak boleh kosong.",
        "Device bulk attribute update file should be .csv": "Berkas pembaruan atribut massal perangkat harus berformat .csv.",
        "Device export limit reached. You can not export more than 100000 devices": "Batas ekspor perangkat telah tercapai. Anda tidak dapat mengekspor lebih dari 100.000 perangkat.",
        "Device import limit reached. You can not import more than 100 devices": "Batas impor perangkat telah tercapai. Anda tidak dapat mengimpor lebih dari 100 perangkat.",
        "Device model and task type compatibility was updated.": "Kompatibilitas model perangkat dan jenis tugas telah diperbarui.",
        "Device model was created.": "Model perangkat telah dibuat.",
        "Device model was deleted.": "Model perangkat telah dihapus.",
        "Device model was updated.": "Model perangkat telah diperbarui.",
        "Device not found": "Perangkat tidak ditemukan.",
        "Device Transfer job was created. Devices will be transfered shortly.": "Tugas pemindahan perangkat telah dibuat. Perangkat akan segera dipindahkan.",
        "Device was added.": "Perangkat telah ditambahkan.",
        "Device was deleted.": "Perangkat telah dihapus.",
        "Device was updated.": "Perangkat telah diperbarui.",
        "Email or password is incorrect.": "Email atau kata sandi yang Anda masukkan salah.",
        "Failed to create Product code": "Gagal membuat kode produk.",
        "Failed to delete Product code": "Gagal menghapus kode produk.",
        "Failed to import devices.": "Gagal mengimpor perangkat.",
        "Failed to Read Product code": "Gagal membaca kode produk.",
        "Failed to retry failed tasks": "Gagal mencoba kembali tugas yang gagal.",
        "Failed to update Product code": "Gagal memperbarui kode produk.",
        "Failed to update task for retry": "Gagal mencoba kembali tugas yang gagal.",
        "Field is not valid": "Kolom ini tidak valid.",
        "File description is too long. Max 255 characters allowed.": "Deskripsi file terlalu panjang. Maksimal 255 karakter diperbolehkan.",
        "File exceeds entries limit of 10000.": "Ukuran file melebihi batas maksimum 10.000.",
        "File must not contain duplicated IMEIs": "File tidak boleh mengandung IMEI yang duplikat.",
        "File must not contain IMEIs that already exist in database.": "File tidak boleh mengandung IMEI yang sudah ada di database.",
        "File must not contain invalid IMEIs": "File tidak boleh mengandung IMEI yang tidak valid.",
        "File name is too long. Max 255 characters allowed.": "Nama file terlalu panjang. Maksimal 255 karakter diperbolehkan.",
        "File name should not contain illegal characters or symbols": "Nama file tidak boleh mengandung karakter khusus.",
        "File not found": "File tidak ditemukan.",
        "File was deleted.": "File telah dihapus.",
        "File was successfully uploaded.": "File telah berhasil diunggah.",
        "File was updated.": "File telah diperbarui.",
        "File was uploaded. Devices will be imported shortly.": "File telah diunggah. Perangkat akan segera diimpor.",
        "File will be created shortly. Check files in a second.": "File akan segera dibuat. Periksa file dalam beberapa detik.",
        "Firmware already exists in global files.": "",
        "Firmware bundle already exists in global files.": "",
        "Firmware file size can't be zero": "Ukuran file firmware tidak boleh nol.",
        "First device in file not found.": "Perangkat pertama dalam file tidak ditemukan.",
        "Forbidden": "Dilarang.",
        "Group name already exist.": "Nama grup sudah ada.",
        "Group was added.": "\"'{{group}}'\" berhasil dibuat.",
        "Group was created.": "Grup telah dibuat.",
        "Group was deleted.": "Grup telah dihapus.",
        "Group was updated.": "Grup telah diperbarui.",
        "Invalid device bulk update attribute": "Atribut pembaruan massal perangkat tidak valid.",
        "Invalid email address.": "Alamat email tidak valid.",
        "Invalid file contents": "Isi file tidak valid.",
        "Invalid file name": "Nama file tidak valid.",
        "Invalid invitation token.": "Token undangan tidak valid.",
        "Invalid token": "Token tidak valid.",
        "Invalid token length": "Panjang token tidak valid.",
        "Internal Server Error": "Kesalahan Server Internal.",
        "Internal users must sign in using Microsoft Entra ID.": "Pengguna internal harus masuk menggunakan Microsoft Entra ID.",
        "License was deleted.": "Lisensi telah dihapus.",
        "License was updated.": "Lisensi telah diperbarui.",
        "Maximum companies hierarchy depth exceeded": "Kedalaman hierarki perusahaan maksimum terlampaui",
        "Maximum device group size exceeded.": "Ukuran grup perangkat maksimum terlampaui.",
        "Method Not Allowed": "Metode Tidak Diizinkan.",
        "Network Error": "Kesalahan Jaringan.",
        "No changes made": "Tidak ada perubahan yang dilakukan.",
        "No resources found.": "Tidak ditemukan sumber daya.",
        "not allowed to affect batch": {
            "description": "Pastikan Anda mengelola perusahaan pengguna yang membuat grup tugas ini.",
            "title": {
                "approve": "Anda tidak memiliki izin untuk menyetujui batch ini.",
                "discard": "Anda tidak memiliki izin untuk membatalkan batch ini."
            }
        },
        "Not Found": "Tidak ditemukan.",
        "Notification was deleted.": "Pemberitahuan telah dihapus.",
        "notify when done title": "Ini mungkin membutuhkan waktu beberapa saat. Tekan tombol di bawah ini untuk menutup layar ini dan Anda akan menerima pemberitahuan saat proses selesai.",
        "Obd record was created.": "Catatan OBD telah dibuat.",
        "Obd record was updated.": "Catatan OBD telah diperbarui.",
        "offline license added": "Lisensi offline \"{{name}}\" telah berhasil ditambahkan.",
        "Offline license was deleted.": "Lisensi offline telah dihapus.",
        "Only id_list source is supported.": "Hanya sumber id_list yang didukung.",
        "Only users with Teltonika email can be invited into internal companies.": "Hanya pengguna yang memiliki alamat email Teltonika yang dapat diundang ke dalam perusahaan internal.",
        "Only users with Teltonika email can be moved into internal companies.": "Hanya pengguna dengan alamat email Teltonika yang dapat dipindahkan ke perusahaan internal.",
        "Parent company cannot be a descendant of the updated company.": "Perusahaan induk tidak boleh menjadi anak perusahaan dari perusahaan yang diperbarui.",
        "Password reset link was sent to Your email.": "Tautan untuk mereset kata sandi telah dikirim ke email Anda.",
        "Password reset token is invalid, expired or related user no longer exists.": "Token reset kata sandi tidak valid, telah kedaluwarsa, atau pengguna tersebut tidak ada lagi.",
        "Password was changed.": "Kata sandi telah diubah.",
        "product code added": "Kode produk \"{{code}}\" telah berhasil ditambahkan.",
        "Product code is too long. Max 200 characters allowed.": "Kode produk terlalu panjang. Maksimal 200 karakter.",
        "ProductCode already exists.": "Kode produk sudah ada.",
        "ProductCode not found": "Kode produk tidak ditemukan.",
        "Product code was deleted.": "Kode produk telah dihapus.",
        "Product code was updated.": "Kode produk telah diperbarui.",
        "Retry failed tasks job was created": "Tugas untuk mengulangi tugas yang gagal telah dibuat.",
        "Role cannot be set for an internal user.": "Peran tidak dapat ditetapkan untuk pengguna internal.",
        "Role was created.": "Peran telah dibuat.",
        "Role was deleted.": "Peran telah dihapus.",
        "Role was updated.": "Peran telah diperbarui.",
        "selected company changed": "Perusahaan yang dipilih telah diubah.",
        "Selected firmware bundle is not supported by the device.": "Paket firmware yang dipilih tidak didukung oleh perangkat.",
        "Server Error": "Kesalahan Server.",
        "signalr connection failed": "",
        "signalr join groups failed": "",
        "SMS was sent.": "SMS telah dikirim.",
        "Something went wrong while saving a new password.": "Terjadi kesalahan saat menyimpan kata sandi baru.",
        "Successfully logged out.": "Anda telah berhasil keluar.",
        "System Admin user level is required in order to perform this action.": "Diperlukan tingkat pengguna Administrator Sistem untuk melakukan tindakan ini.",
        "Target company cannot be a descendant of source company.": "Perusahaan tujuan tidak boleh merupakan anak perusahaan dari perusahaan sumber.",
        "Task create limit exceeded.": "Anda tidak dapat membuat grup tugas untuk lebih dari 100.000 perangkat.",
        "Task type is not retriable": "Jenis tugas tidak dapat dibatalkan",
        "Task was added.": "Tugas telah ditambahkan.",
        "task was created": "Tugas ini dibuat untuk {{imei}} (\"{{taskType}}\"). Tugas ini dapat ditemukan di halaman \"Perangkat\" di bawah bagian \"Tugas\" pada detail perangkat.",
        "Task was updated.": "Tugas telah diperbarui.",
        "Tasks were approved": "Tugas-tugas telah disetujui.",
        "The given data was invalid.": "Data yang diberikan tidak valid.",
        "time zone changed": "Zona waktu telah diubah.",
        "Token cannot be null or empty": "Token tidak boleh bernilai null atau kosong.",
        "token created": "Token API telah berhasil dibuat.",
        "Token has expired": "Token telah kedaluwarsa.",
        "Token's and token's owner companies do not match": "Token dan perusahaan pemilik token tidak cocok.",
        "Token was deleted.": "Token telah dihapus.",
        "Too many resources in the request": "Terlalu banyak sumber daya dalam permintaan",
        "Too Many Requests": "Terlalu Banyak Permintaan.",
        "Transfer token created": "Token transfer telah dibuat.",
        "tutorial completed": "",
        "Two factor authentication is already activated for the user.": "Otentikasi dua faktor sudah diaktifkan untuk pengguna.",
        "Two factor authentication successfully disabled.": "Otentikasi dua faktor telah dinonaktifkan dengan sukses.",
        "Unable to send SMS. This device does not have a GSM number assigned.": "Tidak dapat mengirim SMS. Perangkat ini tidak memiliki nomor GSM yang terdaftar.",
        "Unable to validate Your request.": "Permintaan Anda tidak dapat diverifikasi.",
        "Unauthenticated.": "Tanpa otentikasi.",
        "Unauthorized": "Tidak sah.",
        "User access level is not valid": "Tingkat akses pengguna tidak valid",
        "User invitation was revoked": "Undangan telah berhasil dibatalkan.",
        "User invitation was re-sent": "Undangan pengguna telah dikirim ulang.",
        "User is already in the system.": "Pengguna sudah terdaftar di sistem.",
        "User was created.": "Pengguna telah dibuat.",
        "User was deleted.": "Pengguna telah dihapus.",
        "User was invited.": "Undangan pengguna telah berhasil dikirim.",
        "User was updated": "Pengguna telah diperbarui.",
        "Users count limit exceeded.": "Batas jumlah pengguna terlampaui.",
        "Your password has been changed.": "Kata sandi Anda telah diubah."
    },
    "General": {
        "0": "Pengguna",
        "5": "Dukungan",
        "10": "Admin",
        "15": "Manajer Admin",
        "19": "",
        "20": "Pengguna Sistem",
        "99": "Pengguna Super",
        "--- START-OF-PERMISSIONS ---": "",
        "Company.Create": "Pembuatan perusahaan",
        "Company.Delete": "Hapus perusahaan",
        "Company.Merge": "Penggabungan perusahaan",
        "Company.Update": "Pembaruan perusahaan",
        "Device.Export": "Ekspor perangkat",
        "Device.Read": "Pembacaan perangkat",
        "Device.SecretsRead": "",
        "Device.Transfer": "Transfer perangkat",
        "Device.Unlock": "Pembukaan kunci perangkat",
        "Device.Update": "Pembaruan perangkat",
        "DeviceGroup.Create": "Pembuatan grup perangkat",
        "DeviceGroup.Delete": "Penghapusan grup perangkat",
        "DeviceGroup.Read": "Membaca grup perangkat",
        "DeviceGroup.Update": "Pembaruan grup perangkat",
        "File.Create": "Pembuatan file",
        "File.Delete": "Penghapusan file",
        "File.Download": "Unduh file",
        "File.Read": "Membaca file",
        "File.TctWebAccess": "TCT web",
        "File.Update": "Pembaruan file",
        "Role.Create": "Pembuatan peran",
        "Role.Delete": "Hapus peran",
        "Role.Read": "Peran baca",
        "Role.Update": "Pembaruan peran",
        "Task.Create": "Buat tugas",
        "Task.Read": "Membaca tugas",
        "Task.Retry": "Ulangi tugas",
        "Task.Update": "Pembaruan tugas",
        "TaskGroup.Read": "Kelompok tugas baca",
        "TctIntegration.Access": "Integrasi TCT",
        "Token.Create": "Pembuatan token",
        "Token.Delete": "Penghapusan token",
        "Token.Read": "Pembacaan token",
        "User.Create": "",
        "User.Delete": "Penghapusan pengguna",
        "User.Read": "Pembacaan pengguna",
        "User.Update": "Pembaruan pengguna",
        "--- END-OF-PERMISSIONS ---": "",
        "1_wire_authorization": "",
        "1-wire authorization list": "Daftar otorisasi 1-Wire",
        "1_wire_authorization_list": "Daftar otorisasi 1-Wire",
        "Active": "Aktif",
        "adas_firmware": "Firmware ADAS",
        "apx_firmware": "Firmware APX",
        "assign can package": "Tetapkan paket CAN",
        "assigned package": "Paket yang ditugaskan",
        "automatic": "Otomatis",
        "banner management": "Manajemen banner",
        "batches": "Kelompok tugas",
        "black_box": "Kotak hitam",
        "ble_dtb": "BLE DTB",
        "ble_fw": "Firmware BLE",
        "blue_nrg": "Firmware BlueNRG",
        "bluetooth_authorization": "",
        "BluetoothAuthorizationList": "",
        "bluetooth authorization list": "Daftar otorisasi Bluetooth",
        "bluetooth_authorization_list": "Daftar otorisasi Bluetooth",
        "bluetooth password": "",
        "boolean filtered value name": {
            "task_support": {
                "false": "Tidak kompatibel",
                "true": "Kompatibel"
            },
            "web_editor_support": {
                "false": "TCT web tidak didukung",
                "true": "Dukungan TCT web"
            }
        },
        "can": "CAN",
        "can adapter name": "Nama adaptor CAN",
        "can bootstring": "Bootstring",
        "can configuration": "Konfigurasi OEM",
        "can_debug_log": "Log debug CAN",
        "can oem file package": "Paket file OEM",
        "can oem file vehicle": "File kendaraan OEM",
        "can package": "Paket OEM",
        "can program number": "Nomor program CAN",
        "can revision": "Revisi CAN",
        "can software date": "Tanggal perangkat lunak CAN",
        "can type": "Tipe CAN",
        "Cancelled": "Dibatalkan",
        "cancel task": "Batalkan tugas",
        "can_chip_firmware": "Firmware chip FM CAN",
        "carrier_advance_firmware": "Firmware Carrier Advance",
        "carrier_advance_settings": "Carrier Advance pengaturan",
        "carrier_apx_firmware": "Firmware Carrier APX",
        "carrier_apx_settings": "Pengaturan Carrier APX",
        "carrier_extractions": "Carrier extractions",
        "carrier_logger_files": "File Perekam Suhu Carrier",
        "certificate": "Sertifikat",
        "click for more details": "Klik untuk detail selengkapnya",
        "client ip": "Alamat IP klien",
        "clone model": "Kloning model perangkat",
        "collapse menu": "Tutup menu",
        "companies": "Perusahaan",
        "company": "Perusahaan",
        "company level": "Tingkat perusahaan",
        "company type": "Jenis perusahaan",
        "company name": "Nama perusahaan",
        "Completed": "Selesai",
        "Completed with errors": "Selesai dengan kesalahan",
        "configuration": "Konfigurasi",
        "configuration_36": "Konfigurasi (FM36)",
        "configuration_64": "Konfigurasi (FMB64)",
        "crash_dump": "Log dump crash",
        "created at": "Dibuat pada",
        "created by": "Dibuat oleh",
        "custom": "Sesuai pesanan",
        "custom resource limits": "Batas sumber daya yang dapat disesuaikan",
        "dashboard": "Dasbor",
        "delete desktop license": "Hapus lisensi desktop",
        "delete offline license": "Hapus lisensi offline",
        "desktopLicenses": "Lisensi desktop",
        "device_export_file_csv": "File ekspor perangkat (.csv)",
        "device_export_file_xlsx": "File ekspor perangkat (.xlsx)",
        "deviceModels": "Model",
        "deviceModelTaskCompatibilities": "Kompatibilitas",
        "device_transfer_report": "Laporan transfer perangkat",
        "device group": "Grup",
        "DeviceImportFile": "Berkas impor perangkat",
        "devices": "Perangkat",
        "download file": "Unduh file",
        "download offline license": "Unduh lisensi offline",
        "dsm_firmware": "Firmware DSM",
        "dtb": "DTB",
        "edit compatibility": "Edit kompatibilitas perangkat",
        "edit model": "Edit model perangkat",
        "edit company": "Edit perusahaan",
        "edit desktop license": "Edit lisensi desktop",
        "edit device": "Edit perangkat",
        "edit file": "Edit file",
        "edit group": "Edit grup",
        "edit in tct web": "Edit di TCT web",
        "edit in tct web disabled": "Fitur pengeditan di TCT web hanya tersedia untuk tingkat perusahaan Premium.",
        "edit product code": "Edit kode produk",
        "edit role": "Edit peran",
        "edit smart group": "Edit Grup Cerdas",
        "edit user": "Edit pengguna",
        "Empty": "Kosong",
        "enter here": "Masuk di sini",
        "exception_info": "Informasi pengecualian",
        "Executing": "Menjalankan",
        "expand menu": "Buka menu",
        "Expired": "Sudah kadaluwarsa",
        "Factory": "",
        "Failed": "Gagal",
        "file": "File",
        "file data": "Data file",
        "files": "File",
        "file deleted": "File telah dihapus",
        "firmware": "Firmware",
        "firmware_36": "Firmware (FM36)",
        "firmware_64": "Firmware (FMB64)",
        "Fmx": "FMx",
        "Fota": "",
        "Ft": "FT",
        "fw_bundle": "Paket firmware",
        "fw_bundle_ble": "Paket - Firmware BLE",
        "fw_bundle_ble_dtb": "Paket - BLE DTB",
        "fw_bundle_can": "Paket - Firmware CAN",
        "fw_bundle_can_dtb": "Paket - CAN DTB",
        "fw_bundle_dtb": "Paket - DTB Utama",
        "fw_bundle_mainfw": "Paket - Firmware utama",
        "generic": "",
        "global_configuration": "Konfigurasi global",
        "global_firmware": "Firmware global",
        "gnssm_download_assistant": "Asisten Unduh GNSS-M",
        "gnssm_firmware": "Firmware GNSS-M",
        "group": "Grup",
        "groups": "Kelompok perangkat",
        "hardware key": "Kunci perangkat keras",
        "id": "ID",
        "id_collection_file": "Berkas pengumpulan ID",
        "imei restriction": "Pembatasan IMEI",
        "Inactive": "Tidak aktif",
        "Invalid": "Tidak valid",
        "invalid model": "Model tidak valid",
        "invalid model_name": "Model tidak valid",
        "InvitationExpired": "Undangan telah kedaluwarsa",
        "InvitationPending": "Undangan sedang diproses",
        "Legacy": "Sistem lama",
        "legacy model": "Model lama",
        "legacy model_platform": "Platform lama",
        "legacy platform": "Platform lama",
        "license has expired": "Lisensi telah kedaluwarsa",
        "loading": "Sedang dimuat",
        "log": "Log",
        "MainConfiguration": "",
        "main configuration": "",
        "manual": "Panduan",
        "ManualGeofenceList": "",
        "manual geofence list": "Daftar skenario geofence manual",
        "manual_geofence_list": "Daftar skenario geofence manual",
        "manual_geofence_scenarios": "",
        "meig_modem_firmware": "Firmware modem MeiG",
        "menu": "Menu",
        "modem version": "Versi modem",
        "netprisma_modem_firmware": "Firmware modem NETPRISMA",
        "nmea_log": "Catatan NMEA",
        "no": "Tidak",
        "no results": "Tidak ditemukan hasil awal",
        "no results description": "Segera setelah {{name}} diunggah ke FOTA WEB, Anda dapat melihat datanya di sini",
        "not assigned": "Belum Ditugaskan",
        "not assigned configuration_file_id": "Konfigurasi belum ditetapkan",
        "not assigned current_configuration": "Konfigurasi belum ditetapkan",
        "not assigned current_firmware": "Firmware belum ditetapkan",
        "not assigned firmware_file_id": "Firmware belum ditetapkan",
        "not assigned group_id": "Grup belum ditugaskan",
        "not assigned model": "Model belum ditentukan",
        "not assigned spec_id": "Spec ID belum ditetapkan",
        "not assigned task_type": "Jenis tugas belum ditetapkan",
        "obd_chip_firmware": "Firmware Chip FM OBD",
        "obd chip firmware version": "Versi Firmware Chip OBD",
        "Offline": "Offline",
        "offline licenses": "Lisensi offline",
        "Online": "Online",
        "OneWireAuthorizationList": "",
        "open in tct": "",
        "or": "atau",
        "other": "Lainnya",
        "Pending": "Menunggu",
        "Pending approval": "Menunggu persetujuan",
        "permission disabled": "Dinonaktifkan",
        "permission enabled": "Diaktifkan",
        "productCodes": "Kode produk",
        "psub": "Berkas langganan",
        "quectel_fw": "Firmware modem Quectel (quectel_fw)",
        "quectel_modem_firmware": "Firmware modem Quectel",
        "resend invite": "Kirim ulang undangan",
        "restricted": "Terbatas",
        "retry": "Coba lagi",
        "roles": "Peran dan Izin",
        "Running": "Berjalan",
        "RxAutoscan": "Menerima file CAN hasil pemindaian otomatis",
        "RxBlackBox": "Menerima kotak hitam",
        "RxBluetoothAuthorizationList": "Menerima daftar otorisasi Bluetooth",
        "RxCanDebugLog": "Menerima log debug CAN",
        "RxCarrierExtractions": "Unduh Carrier extractions",
        "RxCarrierLoggerFiles": "Unduh berkas pencatat suhu Carrier",
        "RxConfiguration": "Menerima konfigurasi",
        "RxCrashDump": "Menerima log crash dump",
        "RxExceptionInfo": "Menerima informasi pengecualian",
        "RxLog": "Menerima log internal",
        "RxManualGeofenceList": "Menerima daftar skenario geofence secara manual",
        "RxNmeaLog": "Menerima log NMEA",
        "RxOneWireAuthorizationList": "Menerima daftar otorisasi 1-Wire",
        "RxWdLog": "Menerima log watch-dog (WD)",
        "select company": "Pilih perusahaan",
        "SetBindSim": "Hubungkan perangkat dengan kartu SIM yang saat ini digunakan",
        "SetBluetoothPassword": "",
        "SetDisableFeature": "Nonaktifkan fitur",
        "SetEnableFeature": "Aktifkan fitur",
        "SetForceLockSim": "Kunci paksa SIM",
        "SetUnbindSim": "Lepaskan perangkat dari kartu SIM",
        "simcom_modem_firmware": "",
        "SmsGprs": "",
        "status": "Status",
        "task details": "Rincian tugas",
        "task groups": "Kelompok tugas",
        "tasks": "Kelompok tugas",
        "tasksCompatibility": "Kompatibilitas tugas",
        "task type": "Jenis tugas",
        "Tct": "",
        "time zone": "Zona waktu",
        "total": "Total",
        "tutorials": "Tutorial",
        "TxAdasFirmware": "Unggah firmware ADAS",
        "TxAgpsMt3333": "Transfer file AGPSM",
        "TxAgpsQuectelL89": "Transfer berkas AGPSQ",
        "TxAutoscanCanConfiguration": "Unggah file OEM dengan pemindaian otomatis",
        "TxBleFirmware": "Unggah firmware BLE",
        "TxBlueNrgFirmware": "Unggah firmware BlueNrg",
        "TxBluetoothAuthorizationList": "Unggah daftar otorisasi Bluetooth",
        "TxBundleBle": "Unggah Firmware BLE",
        "TxBundleBleDtb": "Unggah BLE DTB",
        "TxBundleCan": "Unggah Firmware CAN",
        "TxBundleCanDtb": "Unggah CAN DTB",
        "TxBundleDtb": "Unggah DTB Utama",
        "TxBundleFirmware": "Unggah Firmware Utama",
        "TxCanAdapterModeChange": "Ubah mode adaptor CAN eksternal",
        "TxCanAdapterModeChangeInternal": "Ubah mode adaptor CAN internal",
        "TxCanAdapterUpdate": "Unggah firmware adaptor CAN",
        "TxCanAdapterUpdateInternal": "Perbarui adaptor CAN internal",
        "TxCanChipFirmware": "Unggah firmware chip CAN FMXY50",
        "TxCanConfiguration": "Unggah berkas OEM",
        "TxCarrierAdvanceFirmware": "Perbarui firmware Carrier Advance",
        "TxCarrierAdvanceSettings": "Perbarui pengaturan Carrier Advance",
        "TxCarrierApxFirmware": "Perbarui firmware Carrier APX",
        "TxCarrierApxSettings": "Perbarui pengaturan Carrier APX",
        "TxConfiguration": "Konfigurasi unggahan",
        "TxDsmFirmware": "Unggah firmware DSM",
        "TxDtb": "Unggah DTB",
        "TxFirmware": "Unggah firmware",
        "TxFirmwareBundle": "Unggah Kontainer Paket Firmware",
        "TxFirmwareBundleParts": "Unggah paket firmware",
        "TxFotaCertificate": "Perbarui Sertifikat FOTA",
        "TxGenericFile": "",
        "TxGNSSMDownloadAssistant": "Unggah GNSS-M Download Assistant",
        "TxGNSSMFirmware": "Unggah firmware GNSS-M",
        "TxManualGeofenceList": "Unggah daftar skenario geofence secara manual",
        "TxMeigModemDeltaFirmware": "Unggah Firmware MeiG Delta Modem",
        "TxNetprismaModemDeltaFirmware": "Unggah Firmware Modem NETPRISMA Delta",
        "TxObdChipFirmware": "Pembaruan chip OBD",
        "TxObdConfig": "Transfer berkas konfigurasi OBD",
        "TxOneWireAuthorizationList": "Unggah daftar otorisasi 1-Wire",
        "TxPSub": "Transfer berkas langganan",
        "TxQuectelModemDeltaFirmware": "Unggah Firmware Modem Quectel Delta",
        "TxSimcomModemDeltaFirmware": "",
        "TxUserCertificate": "Unggah sertifikat TLS pengguna",
        "users": "Pengguna",
        "Unknown": "Tidak diketahui",
        "unknown": "Tidak diketahui",
        "unknown model_platform": "Platform yang tidak diketahui",
        "unknown origin": "",
        "unknown platform": "Platform yang tidak diketahui",
        "unrestricted": "Tanpa batasan",
        "Verifying": "Memverifikasi",
        "vin": "VIN",
        "vip status": "Status VIP",
        "wd_log": "Log WD",
        "yes": "Ya"
    },
    "Maintenance": {
        "title": "Tunggu sebentar! Kami sedang dalam proses pemeliharaan."
    },
    "Notifications": {
        "description": {
            "{{BackgroundActionType}} failed due to server error": "{{BackgroundActionType}} gagal karena kesalahan server.",
            "Cancel tasks action failed. Invalid request scope. Resources must belong to single root.": "Anda tidak memiliki izin untuk membatalkan semua tugas yang dipilih. Beberapa tugas terkait dengan sumber daya dari perusahaan yang berbeda.",
            "Cancel tasks action failed. No resources found.": "Tidak ada tugas yang sesuai dengan pilihan Anda. Silakan periksa kembali pilihan tugas Anda dan coba lagi.",
            "Company \"{{SourceCompanyName}}\" ({{SourceCompanyId}}) merged into \"{{TargetCompanyName}}\" (<TargetCompanyId>).": "Perusahaan \"{{SourceCompanyName}}\" ({{SourceCompanyId}}) telah bergabung dengan \"{{TargetCompanyName}}\" ({{TargetCompanyId}}).",
            "Company merge failed. Companies '{{SourceCompanyId}}' and '{{TargetCompanyId}}' cannot be merged due to incompatible settings or permissions.": "Penggabungan perusahaan gagal. Perusahaan \"{{SourceCompanyId}}\" dan \"{{TargetCompanyId}}\" tidak dapat digabungkan karena pengaturan atau izin yang tidak kompatibel.",
            "Create device group tasks action failed. No resources found.": "Gagal membuat tugas untuk Smart Group. Silakan coba alokasikan ulang file tersebut.",
            "{{CreatedTaskCount}} task(s) created for device group ID:{{GroupId}} devices.": "{{CreatedTaskCount}} tugas telah dibuat untuk ID grup perangkat: {{GroupId}} perangkat.",
            "Create tasks action failed. Invalid request scope. Resources must belong to single root.": "Anda tidak memiliki izin untuk membuat tugas untuk semua perangkat yang dipilih. Beberapa perangkat milik perusahaan yang berbeda.",
            "Create tasks action failed. No resources found.": "Tidak ada perangkat yang sesuai dengan pilihan Anda. Silakan periksa kembali pilihan perangkat Anda dan coba lagi.",
            "Create tasks action failed. No resources processed.": "Gagal memproses perangkat yang dipilih. Silakan coba buat grup tugas lagi.",
            "Delete companies action failed. Invalid request scope. Resources must belong to single root.": "Anda tidak memiliki izin untuk menghapus semua perusahaan yang dipilih. Beberapa perusahaan tidak berada di bawah pengelolaan langsung Anda.",
            "Delete companies action failed. No resources found.": "Tidak ada perusahaan yang sesuai dengan pilihan Anda. Silakan periksa kembali pilihan perusahaan Anda dan coba lagi.",
            "Delete files action failed. Invalid request scope. Resources must belong to single root.": "Anda tidak memiliki izin untuk menghapus semua file yang dipilih. Beberapa file terkait dengan sumber daya dari perusahaan lain.",
            "Delete files action failed. No resources found.": "Tidak ada file yang sesuai dengan pilihan Anda. Silakan periksa kembali pilihan file Anda dan coba lagi.",
            "Delete groups action failed. Invalid request scope. Resources must belong to single root.": "Anda tidak memiliki izin untuk menghapus semua grup perangkat yang dipilih. Beberapa grup perangkat berisi sumber daya dari perusahaan yang berbeda.",
            "Delete groups action failed. No resources found.": "Tidak ada grup perangkat yang sesuai dengan pilihan Anda. Silakan periksa kembali pilihan grup perangkat Anda dan coba lagi.",
            "Delete product codes action failed. No resources found.": "Tidak ada kode produk yang sesuai dengan pilihan Anda. Silakan periksa kembali pilihan kode produk Anda dan coba lagi.",
            "Delete users action failed. Invalid request scope. Resources must belong to single root.": "Anda tidak memiliki izin untuk menghapus semua pengguna yang dipilih. Beberapa pengguna tergabung dalam perusahaan yang berbeda.",
            "Delete users action failed. No resources found.": "Tidak ada pengguna yang sesuai dengan pilihan Anda. Silakan periksa kembali pilihan pengguna Anda dan coba lagi.",
            "Device group ID:{{GroupId}} move failed. Target company ID:{{TargetCompanyId}} cannot be found.": "ID grup perangkat: {{GroupId}} gagal dipindahkan. ID perusahaan tujuan: {{TargetCompanyId}} tidak ditemukan.",
            "Device group ID:{{GroupId}} successfully moved to company ID:{{TargetCompanyId}}.": "ID grup perangkat: {{GroupId}} telah berhasil dipindahkan ke ID perusahaan: {{TargetCompanyId}}.",
            "{{DevicesCount}} device(s) exported to \"{{Filename}}\".": "{{DevicesCount}} perangkat telah diekspor ke \"{{Filename}}\".",
            "{{DevicesCount}} device(s) imported.": "{{DevicesCount}} perangkat telah diimpor.",
            "{{DevicesProcessedCount}} device(s) processed, {{TasksCreatedCount}} task(s) created.": "{{DevicesProcessedCount}} perangkat telah diproses, {{TasksCreatedCount}} tugas telah dibuat.",
            "Export devices action failed. No resources found.": "Tidak ada perangkat yang sesuai dengan pilihan Anda. Silakan periksa kembali pilihan perangkat Anda dan coba lagi.",
            "{{FailedTaskCount}} task(s) returned to pending in task group {{BatchId}}.": "{{FailedTaskCount}} tugas kembali ke status tertunda dalam grup tugas {{BatchId}}.",
            "Invalid request scope. Resources must belong to single root.": "Ruang lingkup permintaan tidak valid. Sumber daya harus berada di bawah satu akar.",
            "Move device group action failed. No resources found.": "Tidak ada grup perangkat yang sesuai dengan pilihan Anda. Silakan periksa kembali pilihan grup perangkat Anda dan coba lagi.",
            "{{ProcessedCount}} companies deleted.": "{{ProcessedCount}} perusahaan telah dihapus.",
            "{{ProcessedCount}} device group(s) deleted.": "{{ProcessedCount}} grup perangkat telah dihapus.",
            "{{ProcessedCount}} device attribute(s) updated.": "{{ProcessedCount}} atribut perangkat telah diperbarui.",
            "{{ProcessedCount}} device model(s) deleted.": "{{ProcessedCount}} model perangkat telah dihapus.",
            "{{ProcessedCount}} device(s) updated.": "{{ProcessedCount}} perangkat telah diperbarui.",
            "{{ProcessedCount}} file(s) deleted.": "{{ProcessedCount}} file telah dihapus.",
            "{{ProcessedCount}} product code(s) deleted.": "{{ProcessedCount}} kode produk telah dihapus.",
            "{{ProcessedCount}} task(s) canceled.": "{{ProcessedCount}} tugas dibatalkan.",
            "{{ProcessedCount}} task(s) updated.": "{{ProcessedCount}} tugas telah diperbarui.",
            "{{ProcessedCount}} user(s) deleted.": "{{ProcessedCount}} pengguna telah dihapus.",
            "Retry tasks action failed. No resources found.": "Tidak ada tugas yang sesuai dengan pilihan Anda. Silakan periksa kembali pilihan tugas Anda dan coba lagi.",
            "Transfer devices action failed. Invalid request scope. Resources must belong to single root.": "Anda tidak memiliki izin untuk mentransfer semua perangkat yang dipilih. Beberapa perangkat milik perusahaan yang berbeda.",
            "Transfer devices action failed. No resources found.": "Tidak ada perangkat yang sesuai dengan pilihan Anda. Silakan periksa kembali pilihan perangkat Anda dan coba lagi.",
            "Transfer devices action failed. No resources processed.": "Gagal memproses perangkat yang dipilih. Silakan coba mentransfer perangkat lagi.",
            "{{TransferredDevicesCount}} of {{TotalDevicesToTransfer}} device(s) transferred.": "{{TransferredDevicesCount}} dari {{TotalDevicesToTransfer}} perangkat telah ditransfer.",
            "Update devices action failed. Invalid request scope. Resources must belong to single root.": "Anda tidak memiliki izin untuk memperbarui semua perangkat yang dipilih. Beberapa perangkat milik perusahaan yang berbeda.",
            "Update devices action failed. No resources found.": "Tidak ada perangkat yang sesuai dengan pilihan Anda. Silakan periksa kembali pilihan perangkat Anda dan coba lagi.",
            "Update devices attributes action failed. Invalid request scope. Resources must belong to single root.": "Anda tidak memiliki izin untuk memperbarui atribut untuk semua perangkat yang dipilih. Beberapa perangkat milik perusahaan yang berbeda.",
            "Update devices attributes action failed. No resources found.": "Tidak ada perangkat yang sesuai dengan pilihan Anda. Silakan periksa kembali pilihan perangkat Anda dan coba lagi.",
            "Update tasks action failed. Invalid request scope. Resources must belong to single root.": "Anda tidak memiliki izin untuk memperbarui semua tugas yang dipilih. Beberapa tugas terkait dengan sumber daya dari perusahaan yang berbeda.",
            "Update tasks action failed. No resources found.": "Tidak ada tugas yang sesuai dengan pilihan Anda. Silakan periksa kembali pilihan tugas Anda dan coba lagi.",
            "User access is scheduled to expire at {{ExpiresAt}} UTC. To maintain uninterrupted service, please contact your company's administrators immediately to request an extension.": "Akses pengguna akan kedaluwarsa pada pukul {{ExpiresAt}} UTC. Untuk memastikan layanan tetap berjalan tanpa gangguan, silakan hubungi administrator perusahaan Anda segera untuk meminta perpanjangan."
        },
        "no notifications": "Tidak ada pemberitahuan",
        "notifications": "Pemberitahuan",
        "notifications will be listed": "Semua pemberitahuan baru akan tercantum di sini",
        "remove notification": "Hapus pemberitahuan",
        "see previous notifications": "Lihat pemberitahuan sebelumnya",
        "timestamps": {
            "days ago": "{{days}} hari yang lalu",
            "hours ago": "{{hours}} jam yang lalu",
            "minutes ago": "{{minutes}} menit yang lalu",
            "moments ago": "Baru saja"
        },
        "title": {
            "BackgroundActionFailed": "Aksi gagal",
            "CompaniesSuccessfullyDeleted": "Perusahaan yang berhasil dihapus",
            "CompanyBulkDeleteFailed": "Terjadi kesalahan saat menghapus perusahaan",
            "CompanyLevelChanged": "Tingkat perusahaan telah berubah",
            "CompanyLevelDowngradeReminder": "Penurunan tingkat perusahaan yang akan datang",
            "CompanyMergeFailed": "Terjadi kesalahan saat penggabungan perusahaan",
            "CompanySuccessfullyMerged": "Perusahaan yang berhasil merger",
            "DeviceAttributesSuccessfullyUpdated": "Atribut perangkat berhasil diperbarui",
            "DeviceBulkAttributeUpdateFailed": "Terjadi kesalahan saat memperbarui atribut perangkat",
            "DeviceBulkUpdateFailed": "Terjadi kesalahan saat memperbarui perangkat",
            "DeviceExportFailed": "Terjadi kesalahan saat mengekspor perangkat",
            "DeviceGroupMoveFailed": "Terjadi kesalahan saat memindahkan grup perangkat",
            "DeviceGroupsSuccessfullyDeleted": "Grup perangkat berhasil dihapus",
            "DeviceGroupSuccessfullyMoved": "Grup perangkat berhasil dipindahkan",
            "DeviceGroupTasksCreateFailed": "Terjadi kesalahan saat membuat tugas Smart Group",
            "DeviceGroupTasksSuccessfullyCreated": "Tugas Smart Group berhasil dibuat",
            "DeviceModelBulkDeleteFailed": "Terjadi kesalahan saat menghapus model perangkat",
            "DeviceModelsSuccessfullyDeleted": "Model perangkat berhasil dihapus",
            "DevicesSuccessfullyTransferred": "Perangkat berhasil ditransfer",
            "DevicesSuccessfullyUpdated": "Perangkat berhasil diperbarui",
            "DeviceTransferFailed": "Terjadi kesalahan saat mentransfer perangkat",
            "ExportFailed": "Ekspor sumber daya gagal",
            "ExportSucceeded": "Perangkat berhasil diekspor",
            "FailedTasksRetryFailed": "Terjadi kesalahan saat mencoba kembali tugas",
            "FailedTasksSuccessfullyRetried": "Tugas berhasil diulang",
            "FileBulkDeleteFailed": "Terjadi kesalahan saat menghapus file",
            "FilesSuccessfullyDeleted": "File berhasil dihapus",
            "GroupBulkDeleteFailed": "Terjadi kesalahan saat menghapus grup perangkat",
            "ImportFailed": "Impor sumber daya gagal",
            "ImportSucceeded": "Perangkat berhasil diimpor",
            "ProductCodeBulkDeleteFailed": "Terjadi kesalahan saat menghapus kode produk",
            "ProductCodesSuccessfullyDeleted": "Kode produk berhasil dihapus",
            "ResourceUpdateFailed": "Pembaruan sumber daya gagal",
            "ResourceUpdateSucceeded": "Pembaruan sumber daya berhasil",
            "RoleBulkDeleteFailed": "Terjadi kesalahan saat menghapus peran",
            "RolesSuccessfullyDeleted": "Peran telah dihapus dengan sukses",
            "TaskBulkCancelFailed": "Terjadi kesalahan saat membatalkan tugas",
            "TaskBulkCreateFailed": "Terjadi kesalahan saat membuat grup tugas",
            "TaskBulkUpdateFailed": "Terjadi kesalahan saat memperbarui tugas",
            "TaskGroupSuccessfullyCreated": "Grup tugas berhasil dibuat",
            "TasksPropagationFailed": "Pekerjaan penyebaran tugas gagal",
            "TasksPropagationSucceeded": "Tugas penyebaran berhasil",
            "TasksPropagationWarning": "Tugas penyebaran tugas telah selesai dengan peringatan",
            "TasksSuccessfullyCanceled": "Tugas berhasil dibatalkan",
            "TasksSuccessfullyUpdated": "Tugas berhasil diperbarui",
            "UserBulkDeleteFailed": "Terjadi kesalahan saat menghapus pengguna",
            "UserExpireReminder": "Akses FOTA WEB Anda akan segera kedaluwarsa",
            "UsersSuccessfullyDeleted": "Pengguna berhasil dihapus"
        }
    },
    "Permission actions": {
        "Access": "Integrasi TCT",
        "Create": "Buat",
        "Delete": "Hapus",
        "Download": "Unduh",
        "Export": "Ekspor",
        "Merge": "Gabungkan",
        "Read": "Baca",
        "Retry": "Coba lagi",
        "SecretsRead": "",
        "TctWebAccess": "TCT web",
        "Transfer": "Transfer",
        "Unlock": "Buka",
        "Update": "Pembaruan"
    },
    "Permission groups": {
        "company": "Perusahaan",
        "device": "Perangkat",
        "device group": "Kelompok perangkat",
        "file": "File",
        "role": "Peran",
        "task": "Tugas",
        "task group": "Kelompok tugas",
        "token": "Token",
        "user": "Pengguna"
    },
    "Restrictions": {
        "feature_settings": {
            "api_token_support": {
                "input option": "Opsi ini dinonaktifkan untuk pengguna dengan tingkat perusahaan Basic.",
                "token list": "Token integrasi API dinonaktifkan untuk pengguna dengan tingkat perusahaan Basic."
            },
            "custom_role_support": {
                "create role": "Fitur ini hanya dapat digunakan oleh pengguna dengan tingkat keanggotaan Premium.",
                "edit role": "Fitur ini hanya dapat digunakan oleh pengguna dengan tingkat keanggotaan Premium. Peran kustom yang telah dibuat sebelumnya dapat dihapus.",
                "edit user": "Fitur ini hanya dapat digunakan oleh pengguna dengan tingkat perusahaan Premium. Peran khusus yang telah ditetapkan sebelumnya dapat dihapus."
            },
            "task_schedule_support": {
                "table head": "Fitur ini hanya dapat digunakan oleh pengguna dengan tingkat keanggotaan Perusahaan Standar dan Premium. Tugas yang telah dijadwalkan sebelumnya tetap akan dijalankan."
            }
        },
        "general message": "Fitur ini hanya dapat digunakan oleh pengguna dengan tingkat keanggotaan perusahaan Standard dan Premium.",
        "resource_limit_settings": {
            "tasks_per_group": "Anda tidak dapat membuat tugas untuk lebih dari {{limitCount}} perangkat sekaligus."
        }
    },
    "Search": {
        "code": "Kode",
        "description": "Deskripsi",
        "email": "Email",
        "iccid": "ICCID",
        "id": "ID",
        "imei": "IMEI",
        "model": "Model",
        "name": "Nama",
        "product code": "Kode produk",
        "role name": "Nama peran",
        "serial": "Nomor Seri",
        "search by": "Cari berdasarkan",
        "search company name": "Cari nama perusahaan"
    },
    "Security": {
        "2FA": {
            "disable": {
                "confirmation": {
                    "description": "Anda akan menonaktifkan otentikasi dua faktor. Hal ini dapat membuat akun FOTA WEB Anda menjadi tidak aman. Apakah Anda yakin ingin melanjutkan?",
                    "title": "Apakah Anda yakin?"
                },
                "send email code": {
                    "enter code": "Demi keamanan, silakan masukkan kode untuk memverifikasi email."
                },
                "send otp code": {
                    "description": "Kode 6 digit telah dikirim ke aplikasi otentikasi Anda. Demi keamanan, silakan masukkan kode yang dihasilkan ke kolom di bawah ini.",
                    "no access": {
                        "authenticator": "Jika Anda tidak lagi memiliki akses ke aplikasi otentikator yang terhubung dengan akun ini, Anda perlu mengubah kata sandi untuk menonaktifkan otentikasi dua faktor.",
                        "email": "Jika Anda tidak lagi memiliki akses ke email yang terhubung dengan akun ini, Anda perlu mengubah kata sandi untuk menonaktifkan otentikasi multi-faktor."
                    }
                },
                "title": "Nonaktifkan otentikasi dua faktor"
            },
            "get email code": {
                "description": "Gunakan kode tersebut di layar berikutnya untuk memverifikasi akun Anda.",
                "description modal": "Gunakan kode tersebut untuk memverifikasi akun Anda.",
                "title": "Dengan menekan \"Kirim kode\", kode unik akan dikirim ke <1>{{email}}</1>."
            },
            "get secret code": {
                "description": "Anda memerlukan aplikasi otentikasi seluler untuk menyelesaikan proses ini, seperti salah satu dari berikut ini:"
            },
            "select authentication type": {
                "authentication app description": "Dapatkan kode unik dari aplikasi seperti Microsoft Authenticator atau Google Authenticator.",
                "description": "Untuk menjaga keamanan akun dan data klien Anda, silakan gunakan salah satu opsi berikut untuk mengaktifkan Otentikasi Dua Faktor.",
                "description modal": "Pilih metode otentikasi yang Anda inginkan.",
                "email": "Email",
                "email description": "Kami akan mengirimkan kode satu kali ke email Anda setiap kali Anda mencoba masuk.",
                "recommended": "Direkomendasikan",
                "title": "Otentikasi dua faktor (2FA) wajib bagi semua pengguna FOTA WEB.",
                "title modal": "Pilih metode otentikasi"
            },
            "send email code": {
                "description": "Silakan masukkan kode di kolom di bawah ini, lalu tekan \"Verifikasi\" untuk melanjutkan.",
                "enter code": "Silakan masukkan kode untuk memverifikasi email.",
                "title": "Kode unik telah dikirim ke <1>{{email}}</1>.",
                "verification code": "Kode verifikasi"
            },
            "send otp code": {
                "click to scan code": "Klik di sini untuk memindai kode QR",
                "click to type code": "Klik di sini untuk mengetik kode secara manual",
                "incorrect code": "Kode yang salah",
                "scan QR code": "Pindai kode QR ke dalam aplikasi Anda",
                "six digit code": "Kode 6 digit yang dihasilkan oleh aplikasi Anda",
                "title": "Anda memerlukan aplikasi otentikator seluler untuk menyelesaikan proses ini, seperti: <1>Microsoft Authenticator</1> atau <2>Google Authenticator</2>.",
                "type text code": "Masukkan kode teks ke dalam aplikasi Anda"
            },
            "settings": {
                "description": "Otentikasi dua faktor adalah lapisan keamanan tambahan yang memverifikasi identitas Anda menggunakan sesuatu yang Anda ketahui (kata sandi) dan sesuatu yang Anda miliki (ponsel, kunci keamanan, email).",
                "disabled": "Dinonaktifkan",
                "enabled": "Diaktifkan",
                "title": "Otentikasi dua faktor"
            },
            "success message": {
                "alert": "Otentikasi dua faktor telah diaktifkan dengan sukses.",
                "description": "Kami akan meminta kode otentikasi setiap kali Anda masuk menggunakan email dan kata sandi Anda.",
                "title": "Anda telah berhasil mengaktifkan otentikasi dua faktor.",
                "title modal": "Otentikasi dua faktor telah diaktifkan!"
            },
            "title": {
                "authentication app": "Aplikasi otentikasi",
                "authentication email": "Email otentikasi",
                "is enabled": "Otentikasi dua faktor telah diaktifkan.",
                "protect your account": "Lindungi akun FOTA WEB Anda"
            }
        },
        "delete account": {
            "confirmation": {
                "account": "",
                "banner": "",
                "cancel info": "",
                "more info": "",
                "description": "",
                "title": "",
                "verification code description": {
                    "authenticator": "",
                    "email": ""
                }
            },
            "settings": {
                "description": "",
                "title": ""
            }
        },
        "password": {
            "change password": "Ubah kata sandi",
            "enter current password": "Masukkan kata sandi saat ini",
            "enter new password": "Masukkan kata sandi baru",
            "hide password": "Sembunyikan kata sandi",
            "repeat new password": "Ulangi kata sandi baru",
            "rules": {
                "lowercase letter": "Setidaknya satu huruf kecil (a-z)",
                "minimum characters": "Setidaknya 12 karakter",
                "new and current passwords must not match": "Kata sandi baru dan yang lama tidak boleh sama",
                "new passwords must match": "Kata sandi baru harus sama",
                "number": "Setidaknya satu angka",
                "passwords must match": "Kata sandi harus sama",
                "special symbol": "Setidaknya satu simbol khusus (!@#$%^&*()-_=+)",
                "uppercase letter": "Setidaknya satu huruf besar (A-Z)"
            },
            "settings": {
                "description": "",
                "title": ""
            },
            "show password": "Tampilkan kata sandi"
        },
        "recovery codes": {
            "banner description": "Kode-kode ini hanya akan ditampilkan sekali. Simpanlah di tempat yang aman - seperti pengelola kata sandi, salinan cetak di lokasi yang aman, atau berkas terenkripsi.",
            "banner title": "Simpan kode.",
            "checkbox title": "Saya telah menyimpan kode pemulihan saya.",
            "download error message": "Tidak dapat memproses kode-kode tersebut. Format data tidak valid.",
            "first step description": "Kode 6 digit telah dikirim ke aplikasi otentikasi Anda. Demi keamanan, silakan masukkan kode yang dihasilkan di kolom di bawah ini.",
            "first step title": "Buat kode pemulihan",
            "input field title": "Kode pemulihan",
            "print error message": "Tidak dapat membuka jendela cetak. Silakan coba lagi atau periksa apakah browser Anda memblokir pop-up.",
            "second step description": "Kode pemulihan memungkinkan Anda untuk mendapatkan kembali akses ke akun jika Anda kehilangan perangkat atau aplikasi otentikasi Anda.",
            "second step title": "Kode pemulihan dua faktor",
            "settings": {
                "title": "Buat kode pemulihan",
                "description": ""
            }
        },
        "account": "",
        "description": "",
        "security": "",
        "security and account": ""
    },
    "Settings": {
        "version": ""
    },
    "Statistics": {
        "table statistics": "Statistik tabel",
        "statistics message": "Filter tabel akan memengaruhi statistik yang Anda lihat di bawah ini",
        "activity": "Aktivitas",
        "model": "Model",
        "firmware": "Firmware",
        "configuration": "Konfigurasi",
        "statistics": "Statistik"
    },
    "Table": {
        "1_wire_authorization": "Otentikasi 1-Wire",
        "access group": "",
        "access groups": "",
        "access level": "Tingkat akses",
        "accessories": "Aksesori",
        "action": "Tindakan",
        "action date": "Tanggal pelaksanaan",
        "assigned package": "Paket yang ditugaskan",
        "attempt count": "Jumlah upaya",
        "attribute": "Atribut",
        "attributes": "Atribut",
        "auto sync": "",
        "batch id": "ID Batch",
        "ble_dtb": "BLE DTB",
        "ble_fw": "Firmware BLE",
        "bluetooth_authorization": "Otorisasi Bluetooth",
        "bootloader": "Bootloader",
        "can_adapter": "Adaptor CAN",
        "can adapter name": "Nama adaptor CAN",
        "can bootstring": "Bootstring",
        "can oem file package": "Paket file OEM",
        "can oem file vehicle": "File kendaraan OEM",
        "can package": "Paket CAN",
        "can program number": "Nomor program CAN",
        "can software date": "Tanggal perangkat lunak CAN",
        "can type": "Tipe CAN",
        "carrier module id": "ID Modul",
        "carrier revision": "Revisi",
        "carrier serial id": "Nomor Seri",
        "carrier settings filename": "Nama file pengaturan",
        "carrier unit status": "Status",
        "carrier unit type": "Jenis unit",
        "changed at": "Diubah pada",
        "change origin": "",
        "changes": "Perubahan",
        "checkbox disabled": {
            "role": "Peran statis tidak dapat diedit atau dihapus."
        },
        "child company": "<0>Anak perusahaan dari</0><1>{{parentCompany}}</1>",
        "child companies": "Anak perusahaan",
        "code": "Kode",
        "company": "Perusahaan",
        "company hierarchy": "Struktur organisasi perusahaan",
        "company name": "Nama perusahaan",
        "compatibility": "Kompatibilitas",
        "configuration": "Konfigurasi",
        "configuration details": "Rincian konfigurasi",
        "configuration type": "",
        "created at": "Dibuat pada",
        "created by": "Dibuat oleh",
        "date": "Tanggal",
        "description": "Deskripsi",
        "device details": "Rincian perangkat",
        "device company": "Perusahaan perangkat",
        "device description": "Deskripsi perangkat",
        "device group": "Kelompok perangkat",
        "device imei": "Nomor IMEI perangkat",
        "device model": "Model perangkat",
        "device seen at": "Perangkat terlihat di",
        "device serial": "Nomor Seri Perangkat",
        "devices": "Perangkat",
        "devices count": "Jumlah perangkat",
        "Done": "Selesai",
        "download at": "",
        "download file": "Unduh file",
        "dtb": "DTB",
        "edit file": "Edit file",
        "email": "Email",
        "empty table": {
            "no initial results": {
                "description": {
                    "batches": "Segera setelah grup tugas dibuat, Anda dapat melihat daftarnya di sini",
                    "changes": "Segera setelah perubahan dilakukan, Anda dapat melihat daftarnya di sini",
                    "companies": "Segera setelah perusahaan-perusahaan tersebut dibentuk, Anda akan dapat melihat daftarnya di sini",
                    "configurationChanges": "",
                    "desktopLicenses": "Segera setelah lisensi desktop dibuat, Anda akan dapat melihat daftarnya di sini",
                    "devices": "Segera setelah perangkat diunggah ke FOTA WEB, Anda dapat melihat daftarnya di sini",
                    "files": "Segera setelah file diunggah, Anda dapat melihat daftarnya di sini",
                    "groups": "Segera setelah grup dibuat, Anda dapat melihat daftarnya di sini",
                    "offlineLicenses": "Segera setelah lisensi offline dibuat, Anda dapat melihat daftarnya di sini",
                    "permissions": "Segera setelah izin diberikan kepada pengguna, Anda akan dapat melihat daftarnya di sini",
                    "productCodes": "Segera setelah kode produk dibuat, Anda dapat melihat daftarnya di sini",
                    "roles": "Segera setelah peran dibuat, Anda akan dapat melihat daftarnya di sini",
                    "tasks": "Segera setelah tugas dibuat, Anda dapat melihat daftarnya di sini",
                    "users": "Segera setelah pengguna ditambahkan, Anda akan dapat melihat daftarnya di sini"
                },
                "title": {
                    "batches": "Tabel grup tugas kosong",
                    "changes": "Tabel perubahan kosong",
                    "companies": "Tabel perusahaan kosong",
                    "configurationChanges": "",
                    "desktopLicenses": "Tabel lisensi desktop kosong",
                    "devices": "Tabel perangkat kosong",
                    "files": "Tabel file kosong",
                    "groups": "Tabel Grup kosong",
                    "offlineLicenses": "Tabel lisensi offline kosong",
                    "permissions": "Tabel izin kosong",
                    "productCodes": "Tabel kode produk kosong",
                    "roles": "Tabel peran kosong",
                    "tasks": "Tabel tugas kosong",
                    "users": "Tabel pengguna kosong"
                }
            },
            "no permission": {
                "description": "Silakan hubungi administrator Anda untuk meminta akses.",
                "title": "Anda tidak memiliki izin yang diperlukan untuk melihat konten ini"
            },
            "no results found": {
                "description": "Coba kata kunci atau filter lain untuk mendapatkan hasil",
                "title": "Tidak ditemukan hasil"
            },
            "button": {
                "add": {
                    "companies": "Buat perusahaan",
                    "devices": "Tambahkan perangkat",
                    "files": "Unggah file",
                    "groups": "Buat grup",
                    "productCodes": "Tambahkan kode produk",
                    "tasks": "Buat tugas",
                    "users": "Undang pengguna"
                },
                "reset view": "Atur ulang tampilan"
            }
        },
        "exausted autoscan limit": "Batas pemindaian otomatis telah tercapai hingga",
        "exausted vin parsing limit": "Batas pemrosesan VIN telah tercapai hingga",
        "expiration": "Kadaluwarsa",
        "expiration date": "Tanggal kedaluwarsa",
        "expires at": "Berlaku hingga",
        "expiry date": "Tanggal kedaluwarsa",
        "field": "Bidang",
        "file": "File",
        "file id": "ID File",
        "files": "File",
        "file type": "Jenis file",
        "filter by": "Saring berdasarkan",
        "firmware": "Firmware",
        "general": "Umum",
        "general data": "Data umum",
        "gnss version": "Versi GNSS",
        "group": "Grup",
        "groups": "Kelompok perangkat",
        "group vip status": "Status VIP Grup",
        "gsm number": "Nomor GSM",
        "head title info": {
            "auto synced": {
                "changed at": "",
                "download at": "",
                "synced at": "",
                "user sent configuration": ""
            },
            "platform": {
                "fmx platform": "<1>Platform FMx</1> - FMx (FMB, FMU, FMC, FMM), FMT, FMP, TAT, MSP, TFT, TST, GH (GH5200), dan model TMT.",
                "ft platform": "<1>Platform FT</1> - model FTx dan ATx.",
                "legacy platform": "<1>Platform lama</1> - model FM (kecuali FM4001 dan FM3010), FMA, dan GH (GH4000).",
                "title": "Platform untuk pengembangan perangkat telematika"
            },
            "visibility": "<2>Perubahan yang diberi label <1>Internal</1> tidak terlihat oleh klien.</2><2>Karena perubahan pada perangkat dapat mencakup data yang terlihat maupun tersembunyi, <1>jangan membagikan tangkapan layar atau detail dalam komunikasi eksternal</1>.</2>"
        },
        "iccid": "ICCID",
        "id": "ID",
        "imei": "IMEI",
        "imsi": "IMSI",
        "info": "Info",
        "interface": "Antarmuka",
        "invited by": "Diundang oleh",
        "items": "item",
        "last checked at": "Terakhir diperiksa pada",
        "last sign in": "Masuk terakhir",
        "last status update": "Pembaruan status terakhir",
        "last used at": "Terakhir digunakan pada",
        "license disabled": "Dinonaktifkan",
        "license enabled": "Diaktifkan",
        "license key": "Kunci lisensi",
        "license name": "",
        "links": "Tautan",
        "manual_geofence_scenarios": "Skenario geofence manual",
        "message": "Pesan",
        "model": "Model",
        "model task type support": {
            "false": "Tidak didukung",
            "true": "Didukung"
        },
        "modem version": "Versi modem",
        "name": "Nama",
        "new value": "Nilai baru",
        "next task": "Tugas berikutnya",
        "no changes": "Tidak ada perubahan.",
        "no company name": "Tanpa nama perusahaan",
        "no details": "Tidak ada detail",
        "no file": "Tidak ada file",
        "no imei available": "Tidak ada IMEI yang tersedia",
        "no model": "Tidak ada model",
        "no parent company": "Perusahaan ini tidak memiliki perusahaan induk.",
        "no tasks": "Perangkat ini tidak memiliki tugas.",
        "number": "Jumlah",
        "obd": "OBD",
        "obd chip firmware version": "Versi Firmware Chip OBD",
        "of": "dari",
        "offline licenses tab disabled": "Lisensi offline tidak tersedia untuk lisensi desktop yang dinonaktifkan.",
        "origin": "",
        "original value": "Nilai asli",
        "other information": "Informasi lain",
        "page of": "halaman",
        "parent company": "Perusahaan induk",
        "permission count": "Jumlah izin",
        "platform": "Platform",
        "Price": "Harga",
        "product code": "Kode produk",
        "program number": "Nomor program",
        "property": "Properti",
        "queue": "Antrian",
        "receiving company": "Perusahaan penerima",
        "revision": "Revisi",
        "role": "Peran",
        "role name": "Nama peran",
        "rows per page": "Jumlah baris per halaman",
        "running": "Berjalan",
        "schedule": "Jadwal",
        "seen at": "Dilihat di",
        "select row": "Pilih baris untuk melihat detail",
        "send sms": "Kirim SMS",
        "serial": "Nomor Seri",
        "show details": {
            "desktopLicenses": "Tampilkan detail lisensi desktop",
            "devices": "Tampilkan detail perangkat",
            "batches": "Tampilkan detail grup tugas",
            "tasks": "Tampilkan detail tugas",
            "companies": "Tampilkan detail perusahaan"
        },
        "sim": "SIM",
        "size": "Ukuran",
        "software date": "Tanggal perangkat lunak",
        "source company": "Perusahaan asal",
        "spec_id": "Spec ID",
        "status": "Status",
        "status id": "ID Status",
        "status name": "Nama status",
        "supported task types": "Jenis tugas yang didukung",
        "synced at": "",
        "sync mode": "",
        "sync status": "",
        "table columns": "Kolom tabel",
        "target company": "Perusahaan sasaran",
        "task id": "ID Tugas",
        "task queue": "Antrian tugas",
        "tasks": "Tugas",
        "task type": "Jenis tugas",
        "tct web support": "Dukungan TCT web",
        "total": "Total",
        "type": "Jenis",
        "updated at": "Diperbarui pada",
        "updated by": "Diperbarui oleh",
        "unknown": "Tidak diketahui",
        "user cannot be deleted": "Pengguna tidak dapat dihapus.",
        "user cannot be edited": "Pengguna tidak dapat diedit.",
        "user cannot delete himself": "Pengguna tidak dapat menghapus profil mereka sendiri.",
        "user date statuses": {
            "expired": "Sudah kadaluwarsa",
            "expires": "Berlaku hingga",
            "never expires": "Tidak pernah kadaluwarsa",
            "sent": "Dikirim"
        },
        "user email": "Alamat email pengguna",
        "user invitation cannot be cancelled": "Undangan pengguna tidak dapat dibatalkan.",
        "user invitation cannot be resent": "Undangan pengguna tidak dapat dikirim ulang.",
        "user sent configuration": "",
        "user statuses": {
            "Active": "Aktif",
            "Inactive": "Tidak aktif",
            "InvitationExpired": "Undangan telah kedaluwarsa",
            "InvitationPending": "Undangan sedang diproses"
        },
        "users": "Pengguna",
        "value from": "Manfaat dari",
        "value to": "Manfaat bagi",
        "view all roles": "Lihat semua ({{count}})",
        "vin": "VIN",
        "vip status": "Status VIP",
        "visibility": "Visibilitas"
    },
    "Table details": {
        "bluetooth password": {
            "aria label unknown tooltip": "",
            "disabled copy tooltip": "",
            "unknown": "",
            "unknown tooltip": ""
        },
        "device details": {
            "configuration": {
                "badge tooltips": {
                    "not supported": "",
                    "sync failed": "",
                    "syncing": ""
                },
                "configuration details": "",
                "mode descriptions": {
                    "Disabled": "",
                    "Enabled": "",
                    "ReportingOnly": ""
                },
                "mode not supported tooltip": "",
                "mode titles": {
                    "Disabled": "",
                    "Enabled": "",
                    "not supported": "",
                    "ReportingOnly": ""
                },
                "overview": "",
                "status titles": {
                    "cancelled": "",
                    "completed": "",
                    "failed": "",
                    "syncing": ""
                },
                "status tooltips": {
                    "cancelled": "",
                    "completed": "",
                    "failed": "",
                    "syncing": ""
                },
                "sync history": "",
                "sync status": ""
            }
        },
        "device group tasks": "",
        "group tasks": "",
        "number of devices": "",
        "permissions info": "",
        "smart group files": "",
        "tooltip info": {
            "devices": {
                "accessories": {
                    "interface": "Nama antarmuka aksesori.",
                    "type": "jenis aksesori yang terhubung."
                },
                "can": {
                    "assigned package": "Paket OEM yang ditugaskan ke perangkat.",
                    "can oem file package": "Paket OEM yang dilaporkan pada koneksi terakhir.",
                    "can oem file vehicle": "konfigurasi kendaraan OEM yang dilaporkan pada koneksi terakhir.",
                    "dtb": "",
                    "firmware": "versi firmware CAN."
                },
                "can_adapter": {
                    "can adapter name": "",
                    "can bootstring": "String startup adaptor CAN terbaru yang diterima, berisi data saat ini dan nomor program adaptor.",
                    "program number": "nomor program adaptor CAN.",
                    "revision": "",
                    "software date": "Tanggal perangkat lunak adaptor CAN.",
                    "type": "jenis adaptor CAN."
                },
                "configuration overview": {
                    "BluetoothAuthorizationList": "",
                    "MainConfiguration": "",
                    "ManualGeofenceList": "",
                    "OneWireAuthorizationList": ""
                },
                "configuration details": {
                    "1_wire_authorization": "Nama file daftar otorisasi 1-Wire yang terakhir dikirim.",
                    "bluetooth_authorization": "Nama file daftar otorisasi Bluetooth yang terakhir dikirim.",
                    "main configuration": "Nama berkas konfigurasi utama yang terakhir dikirim.",
                    "manual_geofence_scenarios": "Nama file daftar geofence manual yang terakhir dikirim."
                },
                "general": {
                    "ble_dtb": "",
                    "ble_fw": "Versi firmware BLE yang dilaporkan selama koneksi terakhir.",
                    "bluetooth password": "",
                    "bootloader": "versi bootloader perangkat yang dilaporkan pada koneksi terakhir.",
                    "company": "perusahaan yang memiliki perangkat ini.",
                    "configuration": "Nama berkas konfigurasi yang terakhir dikirim.",
                    "description": "Deskripsi perangkat (didefinisikan oleh pengguna).",
                    "dtb": "versi blob pohon perangkat yang dilaporkan selama koneksi terakhir.",
                    "firmware": "versi firmware perangkat yang dilaporkan pada koneksi terakhir.",
                    "gnss version": "versi GNSS yang dilaporkan pada koneksi terakhir.",
                    "group": "kelompok perangkat yang ditugaskan kepada perangkat ini.",
                    "product code": "kode produk perangkat.",
                    "serial": "nomor seri perangkat."
                },
                "obd": {
                    "obd chip firmware version": "versi firmware chip OBD yang dilaporkan pada koneksi terakhir.",
                    "vin": "kode unik berisikan 17 karakter yang mengidentifikasi kendaraan bermotor tertentu."
                },
                "sim": {
                    "gsm number": "nomor telepon umum yang terkait dengan suatu perangkat.",
                    "iccid": "nomor seri unik yang mengidentifikasi kartu SIM.",
                    "imsi": "pengidentifikasi unik untuk pelanggan jaringan seluler."
                }
            },
            "groups": {
                "fmx platform files": {
                    "configuration": "",
                    "firmware": ""
                },
                "ft platform files": {
                    "1_wire_authorization_list": "",
                    "bluetooth_authorization_list": "",
                    "firmware": "",
                    "main configuration": ""
                }
            },
            "users": {
                "general": {
                    "created at": "tanggal dan waktu pembuatan pengguna.",
                    "id": "ID unik pengguna.",
                    "invited by": "Alamat email pengguna yang membuat undangan.",
                    "role": "peran yang diberikan kepada pengguna.",
                    "updated at": "tanggal dan waktu pembaruan terakhir oleh pengguna."
                }
            }
        },
        "user details": "Rincian pengguna"
    },
    "Task groups": {
        "all": "Semua",
        "bulk type": {
            "CompanyBulkDelete": "Hapus perusahaan",
            "DeviceBulkCreate": "Tambahkan perangkat",
            "DeviceBulkDelete": "Hapus perangkat",
            "DeviceBulkUpdate": "Perbarui perangkat",
            "FileBulkDelete": "Hapus file",
            "GroupBulkDelete": "Hapus grup",
            "TaskBulkCreate": "Buat tugas",
            "TaskBulkUpdate": "Batalkan tugas",
            "UserBulkDelete": "Hapus pengguna"
        },
        "pending approval": "Menunggu persetujuan",
        "already approved": "Sudah disetujui",
        "no approval required": "Tidak memerlukan persetujuan",
        "total objects": "Jumlah objek",
        "total tasks": "Jumlah tugas"
    },
    "Task status": {
        "0": "Menunggu",
        "1": "Berjalan",
        "2": "Selesai",
        "3": "Selesai dengan kesalahan",
        "4": "Dibatalkan",
        "5": "Gagal",
        "6": "Sudah kadaluwarsa",
        "7": "Menunggu persetujuan",
        "8": "Memverifikasi",
        "task count": {
            "0": "Tugas yang tertunda",
            "1": "Menjalankan tugas",
            "3": "Tugas yang diselesaikan dengan kesalahan",
            "5": "Tugas yang gagal"
        },
        "verified tooltip title": "Tugas telah berhasil diselesaikan dan diverifikasi oleh perangkat."
    },
    "Tasks": {
        "0": "Tugas tersebut ada dalam antrian dan saat ini sedang menunggu.",
        "1": "Tugas ini sedang berjalan.",
        "2": "Tugas telah diselesaikan dengan sukses.",
        "3": "Tugas telah diselesaikan, tetapi terjadi beberapa kesalahan.",
        "4": "Tugas tersebut dibatalkan.",
        "5": "Tugas tersebut gagal.",
        "6": "Tugas tersebut tidak diselesaikan dalam jangka waktu yang ditentukan."
    },
    "Tct": {
        "edit configuration": "Edit konfigurasi",
        "no editable configurations": "Konfigurasi yang dapat diedit tidak diunggah",
        "open tct": "Buka versi web TCT",
        "open tct description": "Pilih untuk membuat konfigurasi baru di versi TCT web, atau mengedit berkas konfigurasi yang sudah ada dari FOTA WEB.",
        "select configuration file": "Pilih berkas konfigurasi yang ingin Anda edit di TCT web.",
        "tct web": "TCT web",
        "tct web disabled description": "Versi TCT web hanya tersedia untuk tingkat perusahaan Premium."
    },
    "Tutorial": {
        "buttons": {
            "exit": "",
            "finish": "",
            "get started": "",
            "next": "",
            "next feature": ""
        },
        "content": {
            "company selector": {
                "0": "",
                "1": "",
                "1-info": ""
            },
            "finish tutorial": "",
            "first time user": "",
            "task groups": {
                "desktop": {
                    "0": "",
                    "1": ""
                },
                "mobile": {
                    "0": "",
                    "1": ""
                }
            }
        },
        "titles": {
            "finish tutorial": "",
            "first time user": "",
            "tutorial mode": ""
        }
    }
}
